/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/jsx-key */
import React, { useEffect, useMemo, useRef, useState, useCallback } from 'react';
import { Box, Link, Grid, Stack, Divider, Popover, Typography, IconButton, Button, Modal, CircularProgress } from '@mui/material';
import _ from 'lodash';
import ChatAvatarComponent from '../chat/ChatAvatarComponent';
import moment from 'moment';
import {
  lockIcon,
  getBorderColor,
  getTrophyBadge,
  // formatNumberWithCommas,
  GroupBasedRoleFormatter,
  getGoalProgressShowOrNot,
  meetingColor,
  timeZoneWiseTime,
  formattedTimeSlot,
  timeZoneAbbreviation,
  timeZonWiseDateTime,
  checkCallType
} from '../../components/common';
import { UserIcon, EditIcon, ChatIcon, DeleteIcon, VideoCallIcon, PlusCircleIcon } from '../../../../utils/Icons';
// import MyPeers from './MyPeers';
// import AvatarRow from './Avatars';
import { API } from '../../../../api';
import { toast } from 'react-toastify';
// import NewTaskCard from './NewTaskCard';
import {
  // dummyAvatar,
  dummyMyMentorsList
} from '../../../../utils/dummyLoadingData';
import WelcomeModals from './WelcomeModals';
import ProgressChart from './ProgressChart';
import { useAuth0 } from '@auth0/auth0-react';
import UserPeersPopup from './UserPeersPopup';
import Leaderboard from './cards/Leaderboard';
import { useNavigate } from 'react-router-dom';
import MenteeTaskPopup from './MenteeTaskPopup';
import MyMentorSection from './MyMentorSection';
import TaskCardSection from './TaskCardSection';
import YourNextMetting from './YourNextMetting';
import RecruitNewMentor from './RecruitNewMentor';
import MenteeProfileModal from './MentorDash/Components/MenteeProfileModal';
import GettingStartedCard from './GettingStartedCard';
import { useQueryClient } from '@tanstack/react-query';
import GettingStartedModal from './GettingStartedModal';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ArrowBackIosNewOutlinedIcon from '@mui/icons-material/ArrowBackIosNewOutlined';
import ArrowForwardIosOutlinedIcon from '@mui/icons-material/ArrowForwardIosOutlined';
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import AddIcon from '@mui/icons-material/Add';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import FlagOutlinedIcon from '@mui/icons-material/FlagOutlined';
import QuestionAnswerOutlinedIcon from '@mui/icons-material/QuestionAnswerOutlined';
import RestoreIcon from '@mui/icons-material/Restore';
import InsertInvitationOutlinedIcon from '@mui/icons-material/InsertInvitationOutlined';
import CloseIcon from '@mui/icons-material/Close';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import StarIcon from '@mui/icons-material/Star';
import ThumbUpOutlinedIcon from '@mui/icons-material/ThumbUpOutlined';
import { useModule } from '../../../../utils/useModule';
import { levelTypes } from '../../../../utils/constants';
import MySkeleton from '../../../../components/Skeleton';
import { queryKeys } from '../../../../queries/queryKeys';
import { getUserDetails } from '../../../../utils/orgName';
import { openMeetingWithRedirect } from '../../../../utils/openMeetingWithRedirect';
import { useProgramContext } from '../../../../hooks/useProgramContext';
import useMyMentors from '../../../../queries/useMyMentors';
import { useUserRole } from '../../../../utils/useUserRole';
import { CardStyle } from '../../style-components/CardStyling';
import { buttonDisabledSx } from '../../../../components/ui/Buttons/buttonStyles';
// import community from '../../../../assets/images/directory.svg';
import useMenteePeers from '../../../../queries/useMenteePeers';
import DescriptionModal from '../../components/DescriptionModal';
import MeetingDetails from './MeetingDetails';
import useGroupDetails from '../../../../queries/useGroupDetails';
import useGoalProgress from '../../../../queries/useGoalProgress';
import PreviewContent from '../Program/components/PreviewContent';
// import CheckInWithMentorDialog from './CheckInWithMentorDialog';
import useProfileDetails from '../../../../hooks/useProfileDetails';
import useAllGroupTasks from '../../../../queries/useAllGroupTasks';
import { GetTasksLoader } from '../../../../Loader/MenteeHomeLoader';
import greycheckimg from '../../../../assets/images/greycheckimg.svg';
import { getOrfiumLevelName } from '../../../../utils/orfiumFunctions';
import greencheckimg from '../../../../assets/images/greencheckimg.svg';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import useObjectiveProgress from '../../../../queries/useObjectiveProgress';
import { taskActions } from '../../../../redux/slices/goals-tasks/getTasksSlice';
import useResponsiveScreenSwitch from '../../../../utils/useResponsiveScreenSwitch';
import { menteeTaskSlicAction } from '../../../../redux/slices/user-task/userMenteeTask';
import { chatProfileActions } from '../../../../redux/slices/chat-profile/chatProfileSlice';
import { updateXpPoints } from '../../../../redux/slices/menteeXpPoints/menteeXpPointsSlice';
import { fetchUserWorkHistory } from '../../../../redux/slices/user-work/userWorkHistorySlice';
import { fetchUserEducation } from '../../../../redux/slices/user-education/userEducationSlice';
import { fetchCommunityMembers } from '../../../../redux/slices/acs-community-members/acsCommunityMembers';
import MenteeMasterclass from './MenteeMasterclass';
import { Bone } from '../../../../components/ui/DashboardSkeletons';
import { formatDate, fromEpochSeconds } from '../../../../utils/formatDate';
import { eventTracking, events, attributeKeys } from '../../../../utils/amplitude';
import { useMemberWord } from '../../../../utils/memberTypeLabels';

const getObjectiveIdentifier = (obj: any) => {
  if (!obj) return null;
  const key = obj?.objectiveId ?? obj?.id ?? obj?._id ?? obj?.objId ?? obj?.objective ?? obj?.name;
  return key != null ? String(key) : null;
};

const Mentee = () => {
  const selectedGroupId = useAppSelector((state) => state.selectedGroup.data);
  const w = useMemberWord();
  const queryClient = useQueryClient();
  const { isMentee } = useUserRole();
  const mentorRoleText =
    selectedGroupId.id === '64fa3b0ef3cbc20ba20de466' ? 'Matches' : GroupBasedRoleFormatter('mentor', 'Mentors');
  const { user } = useAuth0();
  const { orgId, location: ctxLocation } = useProgramContext();
  const { userId: currentUserId } = getUserDetails();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const classess = CardStyle();
  const selectedUserId = useAppSelector((state) => state.goalTasks.userId);
  const { gettingStarted, objectivesNumber, timezone } = useProfileDetails();
  const { isMasterclass, isMentorship, isHybrid } = useModule(); // Fetching module from Redux state
  const {
    refetch,
    isFetching,
    isLoading,
    data: newData,
    isStale
  } = useAllGroupTasks(selectedGroupId.id, selectedUserId);
  const goalProgress = useGoalProgress(newData?.data?.data[0]?.levels || []);
  const [selectedMember, setSelectedMember] = useState<any>(null);

  const [xpPoints, setXpPoints] = useState<any>();

  /** Getting Started Modal */
  const [openGettingStartedModal, setOpenGettingStartedModal] = useState(false);
  const [selectedStep, setSelectedStep] = useState(0);
  const handleClickGettingStartedModal = (flag: boolean) => {
    setOpenGettingStartedModal(flag);
  };

  /** Welcome Modals */

  /** Check In With Mentor modal */
  // const [checkInWithMentor, setOpenCheckInWithMentor] = useState(true);
  // const handleCheckInWithMentor = (flag: boolean) => { setOpenCheckInWithMentor(flag) };

  const [goalProgressValue, setGoalProgressValue] = useState(0);
  const personalThreadsArr = useAppSelector((state) => state.acsChannels.personalThreadsArr);
  const [displayName, setDisplayName] = useState('');
  const [participantUser, setParticipantUser] = useState([]);
  const [reloadFlag, setReloadFlag] = useState(false);
  const communityMembers = useAppSelector((state) => state.acsCommunityUsers.data);
  const commList = useAppSelector((state) => state.getCommunityMembers.data);
  const groupId = selectedGroupId.id || '';
  const menteeTask = useAppSelector((state) => state?.goalTasks);
  const taskLoading = isLoading;
  const [taskData, setTaskData] = useState<any>([]);
  const { loading: loadingGoal, data: userGoals } = useAppSelector((state) => state.groupDetails) || {};
  const goalCount = Object.keys(userGoals?.goals ? userGoals?.goals : {}).length;
  const [editModalOpen, setEditModalOpen] = React.useState(false);
  const groupDetails = useAppSelector((state) => state?.groupDetails);
  /** Show goal progress */
  const [hasShowGoalProgressValue, setHasShowGoalProgressValue] = useState<any>(true);
  const showGoalProgress = getGoalProgressShowOrNot(hasShowGoalProgressValue) || isMentorship;
  /** For responsive */
  const { forMobile } = useResponsiveScreenSwitch(); // Use the hook
  const [isPeersPopupOpen, setPeersPopupOpen] = React.useState(false);
  const oid = useAppSelector((state) => state.orgDetails.data?.oid);
  const trackerUserEmail = useAppSelector((state) => state.userProfile.data?.personal_details?.email);
  const orgDisplayNameMentee = useAppSelector((state) => state.orgDetails.data?.name);
  const [recentlyScheduledMeeting, setRecentlyScheduledMeeting] = useState(null);
  const [activeMeetingModal, setActiveMeetingModal] = useState<{
    type: 'history' | 'future' | null;
    mentor: any | null;
    objectiveId?: string | null;
  }>({ type: null, mentor: null, objectiveId: null });
  const [meetingHistoryFromApi, setMeetingHistoryFromApi] = useState<{
    past: any[];
    upcoming: any[];
    canceled: any[];
  } | null>(null);
  const [meetingHistoryLoading, setMeetingHistoryLoading] = useState(false);
  const [matchProfilesById, setMatchProfilesById] = useState<Record<string, any>>({});
  const [recruitModalOpen, setRecruitModalOpen] = useState(false);
  const [recruitMentors, setRecruitMentors] = useState<any[]>([]);
  const [recruitMentorsLoading, setRecruitMentorsLoading] = useState(false);
  const [mentorshipProgress, setMentorshipProgress] = useState({
    mentorsEngaged: 0,
    messagesSent: 0,
    meetingsScheduled: 0
  });
  const [currentObjectiveIndex, setCurrentObjectiveIndex] = useState(0);
  const [hasSetObjectiveIndex, setHasSetObjectiveIndex] = useState(false);
  const [markingObjective, setMarkingObjective] = useState(false);
  const [completeModalOpen, setCompleteModalOpen] = useState(false);
  const [cancelMatchModalOpen, setCancelMatchModalOpen] = useState(false);
  const [mentorMenuAnchor, setMentorMenuAnchor] = useState<HTMLElement | null>(null);
  const [mentorMenuData, setMentorMenuData] = useState<any>(null);
  const [profileModalOpen, setProfileModalOpen] = useState(false);
  const [profileMentor, setProfileMentor] = useState<any>(null);
  const [mentorToCancel, setMentorToCancel] = useState<any>(null);
  const [mentorCardIndex, setMentorCardIndex] = useState(0);
  const mentorCardRefs = useRef<(HTMLDivElement | null)[]>([]);
  const mentorSliderScrollRef = useRef<HTMLDivElement | null>(null);
  // The carousel mounts after the objectives load (a spinner first), so its scroll listener binds to
  // the element itself. An effect on the ref ran while it was still null and only bound once the
  // objective changed: on first load the arrows never followed the carousel.
  const [mentorSlider, setMentorSlider] = useState<HTMLDivElement | null>(null);
  const bindMentorSlider = useCallback((el: HTMLDivElement | null) => {
    mentorSliderScrollRef.current = el;
    setMentorSlider(el);
  }, []);
  const MENTOR_CARD_WIDTH = 304;
  const MENTOR_CARD_HEIGHT = 281;
  const MENTOR_CARD_GAP = 20;
  const [myMentorsList, setMyMentorsList] = useState<any[]>([]);
  const [userLearningObjectives, setUserLearningObjectives] = useState<any[]>([]);
  const [userObjectivesLoading, setUserObjectivesLoading] = useState(false);
  const [cardsStatsReady, setCardsStatsReady] = useState(false);
  const inflightMatchProfilesRef = React.useRef<Set<string>>(new Set());
  const handleMeetingScheduled = (meetingDetails: any) => {
    setRecentlyScheduledMeeting(meetingDetails);
    if (doReload) doReload();
  };
  const {
    data: mentorsData,
    isLoading: mentorLoading,
    refetch: mentorsRefetch
  } = useMyMentors({
    grpId: groupId,
    orgId,
    location: ctxLocation
  });
  const {
    data: peersData,
    isLoading: peersLoading,
    refetch: peersRefetch
  } = useMenteePeers({
    grpId: groupId,
    orgId,
    location: ctxLocation
  });
  const loader = mentorLoading || peersLoading;

  const handlePeersPopup = (open: boolean) => {
    setPeersPopupOpen(open);
  };
  const handlePeersOpen = (open: boolean) => {
    setPeersPopupOpen(open);
  };

  const doReload = () => {
    queryClient.invalidateQueries({
      queryKey: [queryKeys.GET_MENTEE_PEERS, groupId]
    });
    queryClient.invalidateQueries({
      queryKey: [queryKeys.GET_MY_MENTORS, groupId]
    });
  };
  const updateMeeting = useAppSelector((state) => state.updateMeeting);

  useEffect(() => {
    setRecentlyScheduledMeeting(null);
  }, [updateMeeting]);

  useEffect(() => {
    mentorsRefetch();
  }, [groupId]);

  // const fetchRecruitMentors = async () => {
  //   try {
  //     setRecruitMentorsLoading(true);
  //     const response = await API.getAllObjectiveMentors({
  //       orgId,
  //       grpId: groupId
  //     });
  //     if (response.data) {
  //       setRecruitMentors(response.data.data || []);
  //     }
  //   } catch (error) {
  //     toast.error(_.get(error, 'response.data.message', 'Failed to fetch mentors'));
  //   } finally {
  //     setRecruitMentorsLoading(false);
  //   }
  // };

  const handleRecruitModalOpen = (open: boolean) => {
    setRecruitModalOpen(open);
    // if (open) {
    //   fetchRecruitMentors();
    // }
  };

  const fetchMentorshipProgress = async () => {
    try {
      const response = await API.getMenteeProgress({ orgId, grpId: groupId });
      if (response.data) {
        setMentorshipProgress(response.data.data);
      }
    } catch (error) {
      console.error('Error fetching mentorship progress:', error);
    }
  };

  useEffect(() => {
    if (groupId) {
      fetchMentorshipProgress();
    }
  }, [groupId, reloadFlag]);

  const [isModalOpen, setModalOpen] = useState(false);
  const [levelDescription, setLevelDescription] = useState('');
  const [levelNumber, setLevelNumber] = useState(0);
  const [levelFullName, setLevelFullName] = useState(0);
  const handleOpenDescription = () => {
    setModalOpen(true);
  };
  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const fetchUserLearningObjectives = useCallback(async () => {
    if (!orgId) return;
    setUserObjectivesLoading(true);
    try {
      const response = await API.UserLearningObjectives({ orgId });
      const payload = response?.data?.data || response?.data || [];
      setUserLearningObjectives(Array.isArray(payload) ? payload : []);
    } catch (error) {
      setUserLearningObjectives([]);
    } finally {
      setUserObjectivesLoading(false);
    }
  }, [orgId]);
  const groupLearningObjectives = groupDetails?.data?.learningObjectives?.objectives || [];
  const programObjectiveLookup = useMemo(() => {
    const lookup = new Map<
      string,
      {
        primaryKey: string;
        objective: any;
      }
    >();
    const programObjectives = Array.isArray(groupLearningObjectives) ? groupLearningObjectives : [];
    programObjectives.forEach((obj: any, idx: number) => {
      const primaryKey =
        getObjectiveIdentifier(obj) ||
        obj?.id ||
        obj?._id ||
        obj?.objectiveId ||
        obj?.objective ||
        obj?.name ||
        `${obj?.objective || obj?.name || 'objective'}_${idx}`;
      if (!primaryKey) return;
      const entry = { primaryKey: String(primaryKey), objective: obj };
      const candidates = [
        primaryKey,
        obj?.objectiveId,
        obj?.id,
        obj?._id,
        obj?.objId,
        obj?.objective,
        obj?.name
      ].filter(Boolean);
      candidates.forEach((candidate) => {
        lookup.set(String(candidate), entry);
      });
    });
    return lookup;
  }, [groupLearningObjectives]);

  const resolveObjectiveFromProgram = useCallback(
    (obj: any) => {
      const candidates = [
        getObjectiveIdentifier(obj),
        obj?.objectiveId,
        obj?.id,
        obj?._id,
        obj?.objId,
        obj?.objective,
        obj?.name
      ].filter(Boolean);
      for (const candidate of candidates) {
        const entry = programObjectiveLookup.get(String(candidate));
        if (entry) {
          return { key: entry.primaryKey, programObjective: entry.objective, inProgram: true };
        }
      }
      if (candidates.length) {
        return { key: String(candidates[0]), programObjective: null, inProgram: false };
      }
      return { key: null, programObjective: null, inProgram: false };
    },
    [programObjectiveLookup]
  );

  const learningObjectives = useMemo(() => {
    // Mentorship: only my learning objectives and my mentors within each (dedupe by id, merge mentors)
    if (isMentorship) {
      const byId = new Map<string, any>();
      (Array.isArray(userLearningObjectives) ? userLearningObjectives : []).forEach((obj: any) => {
        const id = getObjectiveIdentifier(obj) || obj?.id || obj?._id;
        if (!id) return;
        const existing = byId.get(String(id));
        const mentors = Array.isArray(obj?.mentors) ? obj.mentors : [];
        const mergedMentors = existing?.mentors?.length
          ? [...(existing.mentors || []), ...mentors].filter(
              (m: any, i: number, arr: any[]) =>
                arr.findIndex((x: any) => (x?.userId || x?.mid || x?.id) === (m?.userId || m?.mid || m?.id)) === i
            )
          : mentors;
        byId.set(String(id), {
          ...obj,
          objective: obj?.objective || obj?.name || 'Objective',
          mentors: mergedMentors
        });
      });
      return Array.from(byId.values());
    }

    const lookup = new Map<string, any>();

    // 1) Seed with all program (group) objectives so we always show the minimum required by the program
    (Array.isArray(groupLearningObjectives) ? groupLearningObjectives : []).forEach((obj: any, idx: number) => {
      const key =
        getObjectiveIdentifier(obj) ||
        obj?.id ||
        obj?._id ||
        obj?.objectiveId ||
        obj?.objective ||
        obj?.name ||
        `${obj?.objective || obj?.name || 'objective'}_${idx}`;
      if (!key) return;
      lookup.set(String(key), {
        ...obj,
        objective: obj?.objective || obj?.name || 'Objective'
      });
    });

    // 2) Merge user objectives so completed status (and user-specific data) applies to matching program objectives
    const addUserObjective = (obj: any) => {
      const { key, programObjective } = resolveObjectiveFromProgram(obj);
      if (!key) return;

      const base = lookup.get(key) || programObjective || {};
      const merged = {
        ...base,
        ...obj,
        objective: obj?.objective || obj?.name || base?.objective || base?.name || 'Objective'
      };
      lookup.set(key, merged);
    };

    (Array.isArray(userLearningObjectives) ? userLearningObjectives : []).forEach(addUserObjective);

    return Array.from(lookup.values());
  }, [isMentorship, groupLearningObjectives, resolveObjectiveFromProgram, userLearningObjectives]);
  const objProgress = useObjectiveProgress(learningObjectives || []);
  const normalizeMatchId = (value: any) => {
    if (!value) return '';
    const str = String(value);
    return str
    // return str.startsWith('auth0|') ? str.slice('auth0|'.length) : str;
  };

  const fetchMatchProfileIfNeeded = async (matchId: string) => {
    if (!matchId || matchProfilesById[matchId]) return;
    if (inflightMatchProfilesRef.current.has(matchId)) return;
    inflightMatchProfilesRef.current.add(matchId);
    try {
      const response = await API.getMatchProfile({ orgId, confirmMatchId: matchId });
      if (response?.status === 200) {
        setMatchProfilesById((prev) => (prev[matchId] ? prev : { ...prev, [matchId]: response?.data?.data }));
      }
    } catch (error) {
      // no-op
    } finally {
      inflightMatchProfilesRef.current.delete(matchId);
    }
  };
  useEffect(() => {
    const list =
      mentorsData?.data?.data ||
      mentorsData?.data ||
      mentorsData ||
      [];
    if (Array.isArray(list) && list.length) {
      setMyMentorsList(list);
    }
  }, [mentorsData]);

  useEffect(() => {
    fetchUserLearningObjectives();
  }, [groupId, fetchUserLearningObjectives]);

  useEffect(() => {
    const mentors = Array.isArray(myMentorsList) ? myMentorsList : [];
    const matchIdsFromList = mentors
      .map((mentor: any) =>
        normalizeMatchId(
          mentor?.matchId ?? mentor?.confirmMatchId ?? mentor?.match_id ??
            (mentor?.match && (mentor.match.id ?? mentor.match._id ?? mentor.match.matchId))
        )
      )
      .filter(Boolean)
      .map((id) => String(id));
    const fromObjectives: string[] = [];
    if (Array.isArray(learningObjectives)) {
      learningObjectives.forEach((objective: any) => {
        const list = Array.isArray(objective?.mentors) ? objective.mentors : [];
        list.forEach((mentor: any) => {
          const id = normalizeMatchId(
            mentor?.matchId ?? mentor?.confirmMatchId ?? mentor?.match_id ??
              (mentor?.match && (mentor.match?.id ?? mentor.match?._id ?? mentor.match?.matchId))
          );
          if (id) fromObjectives.push(id);
        });
      });
    }
    const allMatchIds = [...new Set([...matchIdsFromList, ...fromObjectives])];
    const uniqueToFetch = allMatchIds.filter((matchId) => !matchProfilesById[matchId]);

    const hasCards = mentors.length > 0 || allMatchIds.length > 0;
    if (!hasCards) {
      setCardsStatsReady(true);
      return;
    }
    if (!orgId) return;
    if (!uniqueToFetch.length) {
      setCardsStatsReady(true);
      return;
    }

    setCardsStatsReady(false);
    let isActive = true;
    const fetchMatchProfiles = async () => {
      await Promise.all(
        uniqueToFetch.map(async (matchId) => {
          try {
            const response = await API.getMatchProfile({ orgId, confirmMatchId: matchId });
            if (response?.status === 200 && isActive) {
              const incomingProfile = response?.data?.data;
              setMatchProfilesById((prev) => {
                if (prev[matchId]) return prev;
                const next: Record<string, any> = { ...prev, [matchId]: incomingProfile };
                return next;
              });
            }
          } catch (error) {
            // no-op
          }
        })
      );
      if (isActive) setCardsStatsReady(true);
    };
    fetchMatchProfiles();

    return () => {
      isActive = false;
    };
  }, [myMentorsList, learningObjectives, orgId, matchProfilesById]);

  useEffect(() => {
    setHasSetObjectiveIndex(false);
  }, [groupId]);
  const [selectedLevelId, setSelectedLevelId] = useState<any[]>([]);
  const [selectedLevelName, setSelectedLevelName] = useState('');
  const [rightTopPop, setRightTopPop] = useState(null);
  const rightTopDotsClick = (level: any) => (event: any) => {
    setEditModalOpen(true);
    setSelectedLevelId(level._id);
    setSelectedLevelName(level.levelName);
    setRightTopPop(event.currentTarget);
  };
  const handleClose = () => {
    setRightTopPop(null);
    setEditModalOpen(false);
  };
  const openMoreVerts = Boolean(rightTopPop);
  const rightTopPopover = openMoreVerts ? 'simple-popover' : undefined;
  const avatars = peersData?.data.data[0]?.menteeDetails.map((each: any) => ({
    avatar: each?.headshot,
    firstName: each?.displayName
  }));
  const groupList = useAppSelector((state) => state.groupRoleList);
  const moveToUsercommunityProfile = (userId: string) => {
    const mem = communityMembers.find((item: { userId: string }) => item.userId === userId);
    const modifiedMem = { ...mem, id: _.get(mem, 'id.coId', '') };
    if (mem) {
      navigate('/app/communitymember', {
        state: { mem: modifiedMem, allCommunityMembersList: commList }
      });
    }
  };

  const getMenteesInsights = async () => {
    // Never let this reject unhandled — the endpoint's strict two-sided
    // mentee-membership check 400s for learners enrolled one-sided, and an
    // uncaught rejection here crashes the page overlay in dev.
    try {
      const menteeInsightsData = await API.getMenteeInsights(orgId, ctxLocation, groupId);
      if (menteeInsightsData) {
        setXpPoints(menteeInsightsData?.data?.xpPoints);
        dispatch(updateXpPoints(menteeInsightsData?.data?.xpPoints));
        setGoalProgressValue(menteeInsightsData?.data?.goalProgress);
        setHasShowGoalProgressValue(menteeInsightsData?.data?.showGoalProgress);
      }
    } catch (e) {
      console.warn('[mentee] insights unavailable for this group', e);
    }
  };

  const getChannels = () => {
    dispatch(
      fetchCommunityMembers({
        orgId,
        location: ctxLocation
      })
    );
  };

  const [helpfulTips, setHelpfulTips] = useState([]);
  const [articleData, setArticleData] = useState(null);
  const [openPreview, setOpenPreview] = useState(false);
  const [articleDataLoading, setArticleDataLoading] = useState(false);
  const [mentorshipHoursValue, setMentorshipHours] = useState('00:00');
  const [mentorRoi, setMentorRoi] = useState<any>(0);

  const handelOnClickPreviewArticleName = async (articleId: string, location: string) => {
    setArticleDataLoading(true);
    setOpenPreview(true);
    try {
      const response = await API.getAllArticleById({
        orgId: orgId,
        articleId: articleId,
        isContentSettings: false,
        articleLocation: location ? location : ''
      });
      if (response && response.status === 200) {
        setArticleData(response.data.article);
        setHelpfulTips((prevTips: any) =>
          prevTips.map((tip: any) => (tip._id === articleId ? { ...tip, isRead: true } : tip))
        );
      }
    } catch (error) {
      toast.error(_.get(error, 'response.data.message', 'Something went wrong, please try again'));
      setOpenPreview(false);
    } finally {
      setArticleDataLoading(false);
    }
  };

  const getMenteeHelpfulTips = async () => {
    const response = await API.getHelpfulTips({ groupId: groupId, role: 'mentee', location: ctxLocation });
    if (response.status === 200) {
      setMentorshipHours(response?.data?.mentorshipHours);
      const formattedMentorROI = new Intl.NumberFormat('en-US', {
        notation: 'compact',
        maximumFractionDigits: 1
      }).format(response?.data?.mentorROI);

      setMentorRoi(formattedMentorROI);
      setHelpfulTips(response?.data?.data);
    }
  };

  useEffect(() => {
    getMenteeHelpfulTips();
  }, [groupId]);

  useEffect(() => {
    if (groupDetails.data) {
      const allowEditing = groupDetails?.data?.includeTask && groupDetails?.data?.allowEditing ? true : false;
      // if (!gettingStarted.editTasks && allowEditing) {
      //   setOpenGettingStartedModal(true);
      // }
      // if (!gettingStarted.nonEditTasks && !allowEditing) {
      //   setOpenGettingStartedModal(true);
      // }
      if (!gettingStarted) {
        setOpenGettingStartedModal(true);
      }
    }
  }, [groupId, gettingStarted, groupDetails.data]);

  useEffect(() => {
    getChannels();
  }, []);

  useEffect(() => {
    if (menteeTask) {
      setTaskData(newData?.data?.data);
    } else {
      setTaskData([]);
    }
  }, [newData]);

  const { refetch: fetchGroupDetails } = useGroupDetails(groupId, ctxLocation);

  useEffect(() => {
    try {
      if (groupId) {
        fetchGroupDetails();
      }
    } catch (error) {}
  }, [groupId]);

  const saveAnswer = useAppSelector((state) => state.saveAnswer.flag);
  useEffect(() => {
    if (isStale && !saveAnswer && !isMentorship) {
      refetch();
    }
  }, [selectedGroupId.id, selectedUserId, saveAnswer, isStale]);

  useEffect(() => {
    if (selectedMember?.userId) {
      dispatch(fetchUserWorkHistory(selectedMember?.userId));
      dispatch(fetchUserEducation(selectedMember?.userId));
    }
    if (groupId) {
      if (isMentee) {
        dispatch(taskActions.setUserId({ userId: '' }));
      }
    }
  }, []);

  const getName = (each: any) => {
    const chatProfileFirstName: any = _.get(each, 'firstName', '');
    const chatProfileLastName: any = _.get(each, 'lastName', '');
    return chatProfileFirstName
      ?.charAt(0)
      ?.toUpperCase()
      ?.concat(chatProfileFirstName?.slice(1)?.toLowerCase())
      ?.concat(
        ' ',
        chatProfileLastName?.charAt(0)?.toUpperCase()?.concat(chatProfileLastName?.slice(1)?.toLowerCase())
      );
  };

  const navigateMember = (member: any) => {
    setSelectedMember(member);
  };

  const handleOpenMentorMenu = (event: React.MouseEvent<HTMLElement>, mentor: any) => {
    setMentorMenuAnchor(event.currentTarget);
    setMentorMenuData(mentor);
  };

  const handleCloseMentorMenu = () => {
    setMentorMenuAnchor(null);
    setMentorMenuData(null);
  };

  const handleViewMentorProfile = async (mentor?: any) => {
    const targetMentor = mentor || mentorMenuData;
    if (!targetMentor) {
      handleCloseMentorMenu();
      return;
    }
    handleCloseMentorMenu();

    const userId =
      targetMentor.mentorUserId ||
      targetMentor.mentorId ||
      targetMentor.userId ||
      targetMentor.user_id ||
      targetMentor.id ||
      targetMentor.mid ||
      targetMentor._id ||
      targetMentor.user?.id ||
      targetMentor.user?._id ||
      targetMentor.user?.userId;

    const fallbackUser = {
      ...targetMentor,
      name: targetMentor.displayName || targetMentor.name || targetMentor.fullName || w('mentor'),
      id: userId || targetMentor.id,
      _id: userId || targetMentor._id
    };

    try {
      if (userId) {
        const response = await API.getUserDetailsById(String(userId));
        setProfileMentor(response?.data?.data ?? fallbackUser);
      } else {
        setProfileMentor(fallbackUser);
      }
    } catch (error) {
      console.error('Failed to fetch mentor profile', error);
      setProfileMentor(fallbackUser);
    } finally {
      setProfileModalOpen(true);
    }
  };

  const handleOpenMeetingModal = (mentor: any, type: 'history' | 'future', objectiveId?: string | null) => {
    setActiveMeetingModal({
      type,
      mentor,
      objectiveId: objectiveId ?? mentor?.objectiveId ?? null
    });
  };

  const handleCloseMeetingModal = () => {
    setActiveMeetingModal({ type: null, mentor: null, objectiveId: null });
    setMeetingHistoryFromApi(null);
    setMeetingHistoryLoading(false);
  };

  useEffect(() => {
    const { type, mentor } = activeMeetingModal;
    if ((type !== 'history' && type !== 'future') || !mentor || !orgId) {
      return;
    }
    // Load review/details from UserLearningObjectives (callDetails, callReview, menteeRating, mentorRating)
    fetchUserLearningObjectives();
    const mentorKey = mentor?.mentorId || mentor?.userId || mentor?.id || mentor?.mid;
    const mentorFromList = Array.isArray(myMentorsList)
      ? myMentorsList.find((entry: any) => {
          const entryKey = entry?.mentorId || entry?.userId || entry?.id || entry?.mid;
          return entryKey && mentorKey && String(entryKey) === String(mentorKey);
        })
      : null;
    let rawMatchId =
      mentorFromList?.matchId ??
      mentorFromList?.confirmMatchId ??
      mentor?.matchId ??
      mentor?.confirmMatchId ??
      mentor?.match_id ??
      (mentor?.match && (mentor.match.id ?? mentor.match._id ?? mentor.match.matchId)) ??
      '';
    if (!rawMatchId && Array.isArray(learningObjectives)) {
      for (const objective of learningObjectives) {
        const list = Array.isArray(objective?.mentors) ? objective.mentors : [];
        for (const m of list) {
          const entryKey = m?.mentorId ?? m?.userId ?? m?.id ?? m?.mid;
          if (entryKey && String(entryKey) === String(mentorKey)) {
            const id = m?.matchId ?? m?.confirmMatchId ?? m?.match_id ?? m?.match?.id ?? m?.match?._id ?? m?.match?.matchId;
            if (id) {
              rawMatchId = id;
              break;
            }
          }
        }
        if (rawMatchId) break;
      }
    }
    const matchId = normalizeMatchId(rawMatchId);
    if (!matchId) {
      setMeetingHistoryFromApi({ past: [], upcoming: [], canceled: [] });
      setMeetingHistoryLoading(false);
      return;
    }
    let cancelled = false;
    setMeetingHistoryLoading(true);
    setMeetingHistoryFromApi(null);
    API.getMatchProfile({ orgId, confirmMatchId: matchId })
      .then((response) => {
        if (cancelled) return;
        const data = response?.data?.data ?? response?.data;
        const meetingHistory = data?.meetingHistory ?? {};
        setMeetingHistoryFromApi({
          past: Array.isArray(meetingHistory.past) ? meetingHistory.past : [],
          upcoming: Array.isArray(meetingHistory.upcoming) ? meetingHistory.upcoming : [],
          canceled: Array.isArray(meetingHistory.canceled) ? meetingHistory.canceled : []
        });
      })
      .catch(() => {
        if (!cancelled) setMeetingHistoryFromApi({ past: [], upcoming: [], canceled: [] });
      })
      .finally(() => {
        if (!cancelled) setMeetingHistoryLoading(false);
      });
    return () => {
      cancelled = true;
    };
    // Use stable id so effect doesn't re-run when mentor object reference changes (avoids infinite loop)
  }, [
    activeMeetingModal.type,
    activeMeetingModal.mentor?.mentorId ?? activeMeetingModal.mentor?.userId ?? activeMeetingModal.mentor?.id ?? activeMeetingModal.mentor?.mid,
    orgId,
    fetchUserLearningObjectives
  ]);

  const handleCancelMatchClick = () => {
    setMentorToCancel(mentorMenuData);
    handleCloseMentorMenu();
    setCancelMatchModalOpen(true);
  };

  const handleConfirmCancelMatch = () => {
    // TODO: Integrate actual cancel match API call when available
    const targetName = mentorToCancel ? getMentorDisplayName(mentorToCancel) : w('mentor', { lower: true });
    toast.info(`Cancel match requested for ${targetName}`);
    setCancelMatchModalOpen(false);
    setMentorToCancel(null);
  };

  /** Calendar modal */
  const handleCalendarOpen = (member: any) => {
    setDisplayName(member.displayName);
    setParticipantUser(member);
    // setPeersOpen(false);
  };

  const navigateToChat = () => {
    let communicationId = _.get(selectedMember, 'communicationUserId', '');
    if (!communicationId) {
      communicationId = _.get(selectedMember, 'communicationId', '');
    }
    const channel = personalThreadsArr?.find((each) => each?.displayNames?.includes(communicationId));
    dispatch(chatProfileActions.atnSetChatProfileState(null));
    if (communicationId && channel) {
      navigate(`/app/chat/?threadid=${_.get(channel, 'id')}&type=Chats&name=${_.get(channel, 'topic')}`);
    } else if (communicationId && !channel) {
      navigate(`/app/chat/?commId=${communicationId}`);
    }
  };

  useEffect(() => {
    if (selectedMember) {
      navigateToChat();
    }
  }, [selectedMember]);

  useEffect(() => {
    if (typeof groupId === 'string' && groupId !== '') {
      queryClient.fetchQuery({
        queryKey: [queryKeys.GET_MENTEE_PEERS, groupId]
      });
      // Mentorship-only data: pure courses (masterclass without mentorship)
      // never need mentee insights or mentor lists — skipping also avoids
      // the endpoints' mentee-membership 400/401s for course learners.
      const isPureCourse = isMasterclass && !isMentorship && !isHybrid;
      if (!isPureCourse) {
        getMenteesInsights();
        queryClient.fetchQuery({
          queryKey: [queryKeys.GET_MY_MENTORS, groupId]
        });
      }
    }
  }, [groupId, reloadFlag, isMasterclass, isMentorship, isHybrid]);

  if (groupList.error) {
    return <Box>{groupList.errorText}</Box>;
  }

  if (groupList.data?.length === 0) {
    return <Box>No Groups found</Box>;
  }

  const handleAddLevels = () => {
    dispatch(menteeTaskSlicAction.openDialog({ isOpen: true, mode: 'add' }));
  };
  const handleAddTasks = (level: any) => {
    dispatch(menteeTaskSlicAction.setSelectedLevel({ selectedLevel: level.levelName, selectedLevelId: level._id }));
    dispatch(menteeTaskSlicAction.openDialog({ isOpen: true, mode: 'addTask' }));
  };

  const handleEditLevel = () => {
    dispatch(
      menteeTaskSlicAction.setSelectedLevel({
        selectedLevel: selectedLevelName,
        selectedLevelId: selectedLevelId
      })
    );
    dispatch(menteeTaskSlicAction.openDialog({ isOpen: true, mode: 'edit' }));
    // handleClose();
  };

  const handleDeleteLevel = () => {
    dispatch(
      menteeTaskSlicAction.setSelectedLevel({
        selectedLevelId: selectedLevelId
      })
    );
    dispatch(menteeTaskSlicAction.openDialog({ isOpen: true, mode: 'delete' }));
    // handleClose();
  };
  const currentDate = Date.now() / 1000;

  function getAvailabilityMessage(startDate: any, endDate: any, type: string, dateType?: string) {
    let color = '';
    let text = '';
    if (!startDate && !endDate) {
      text = '';
    } else if (startDate && !endDate) {
      if (currentDate >= startDate) {
        text = '';
      } else {
        text = `Available ${formatDate(fromEpochSeconds(startDate))} `;
      }
    } else if (currentDate < startDate) {
      text = `Available ${formatDate(fromEpochSeconds(startDate))} `;
    } else if (currentDate >= startDate && currentDate <= endDate) {
      const timeLeft = endDate - currentDate;
      if (timeLeft <= 7 * 24 * 3600) {
        // 7 days in seconds
        color = 'orange';
      } else {
        color = '';
      }
      text = `Due ${formatDate(fromEpochSeconds(endDate))}`;
    } else if (currentDate > endDate) {
      color = 'red';
      text = `Due ${formatDate(fromEpochSeconds(endDate))}`;
    } else {
      text = '';
    }

    if (type === 'level') {
      return (
        <Typography fontSize={'12px'} fontStyle={'italic'} color={dateType === levelTypes.availableSoon ? '' : color}>
          {dateType === levelTypes.availableSoon ? 'Available soon' : text}
        </Typography>
      );
    }

    return (
      <Typography
        bottom={'-12px'}
        fontSize={'12px'}
        lineHeight={'14px'}
        fontStyle={'italic'}
        position={'absolute'}
        color={color}
      >
        {text}
      </Typography>
    );
  }

  const getIsTaskStarted = (startDate: any) => {
    if (!startDate || currentDate >= startDate) {
      return true;
    }
    return false;
  };

  const getLevelText = (level: any) => {
    if (level?.startDate?.type === levelTypes.availableSoon) {
      return 'soon';
    }
    return `on ${formatDate(fromEpochSeconds(level?.startDate.value))}`;
  };

  const getPreferredObjectiveIndex = (objs: any[]) => {
    if (!Array.isArray(objs) || objs.length === 0) {
      return 0;
    }
    const inProgressIndex = objs.findIndex((obj) => obj.status === 'inprogress' && obj.objective);
    if (inProgressIndex !== -1) {
      return inProgressIndex;
    }
    const todoIndex = objs.findIndex((obj) => obj.status === 'to-do' && obj.objective);
    if (todoIndex !== -1) {
      return todoIndex;
    }
    return 0;
  };

  useEffect(() => {
    if (!learningObjectives.length) {
      setCurrentObjectiveIndex(0);
      return;
    }

    setCurrentObjectiveIndex((prev) => {
      if (!hasSetObjectiveIndex) {
        return getPreferredObjectiveIndex(learningObjectives);
      }
      if (prev >= learningObjectives.length) {
        return learningObjectives.length - 1;
      }
      return prev;
    });

    if (!hasSetObjectiveIndex) {
      setHasSetObjectiveIndex(true);
    }
  }, [learningObjectives, hasSetObjectiveIndex]);

  /** Scroll to first card when objective changes */
  useEffect(() => {
    setMentorCardIndex(0);
    const container = mentorSliderScrollRef.current;
    if (container) {
      container.scrollTo({ left: 0, behavior: 'smooth' });
    }
  }, [currentObjectiveIndex]);

  /** Derive active index from scroll: o card ativo é o que está no centro horizontal do viewport */
  const updateMentorCardIndexFromScroll = useCallback(() => {
    const container = mentorSliderScrollRef.current;
    if (!container) return;
    const containerRect = container.getBoundingClientRect();
    const viewportCenterX = containerRect.left + containerRect.width / 2;
    let bestIndex = 0;
    let bestDistance = Infinity;
    const refs = mentorCardRefs.current;
    for (let i = 0; i < refs.length; i++) {
      const card = refs[i];
      if (!card) continue;
      const cardRect = card.getBoundingClientRect();
      const cardCenterX = cardRect.left + cardRect.width / 2;
      const distance = Math.abs(cardCenterX - viewportCenterX);
      if (distance < bestDistance) {
        bestDistance = distance;
        bestIndex = i;
      }
    }
    setMentorCardIndex(bestIndex);
  }, []);

  // Binds to the carousel element itself (bindMentorSlider): see there.
  useEffect(() => {
    if (!mentorSlider) return;
    updateMentorCardIndexFromScroll();
    mentorSlider.addEventListener('scroll', updateMentorCardIndexFromScroll);
    return () => mentorSlider.removeEventListener('scroll', updateMentorCardIndexFromScroll);
  }, [mentorSlider, currentObjectiveIndex, updateMentorCardIndexFromScroll]);

  /** Move os cards para que o card alvo fique no centro (highlight fixo no centro) */
  const scrollMentorToIndex = useCallback((targetIndex: number) => {
    const container = mentorSliderScrollRef.current;
    const cardEl = mentorCardRefs.current[targetIndex];
    if (!container) return;
    if (targetIndex <= 0) {
      container.scrollTo({ left: 0, behavior: 'smooth' });
      return;
    }
    if (cardEl) {
      const containerRect = container.getBoundingClientRect();
      const cardRect = cardEl.getBoundingClientRect();
      const containerCenterX = containerRect.left + containerRect.width / 2;
      const cardCenterX = cardRect.left + cardRect.width / 2;
      const delta = cardCenterX - containerCenterX;
      const targetScroll = container.scrollLeft + delta;
      const maxScroll = Math.max(0, container.scrollWidth - container.clientWidth);
      container.scrollTo({
        left: Math.max(0, Math.min(targetScroll, maxScroll)),
        behavior: 'smooth'
      });
    } else {
      const cardStep = MENTOR_CARD_WIDTH + MENTOR_CARD_GAP;
      const targetScroll = Math.max(0, targetIndex * cardStep);
      const maxScroll = Math.max(0, container.scrollWidth - container.clientWidth);
      container.scrollTo({ left: Math.min(targetScroll, maxScroll), behavior: 'smooth' });
    }
  }, []);

  const getTasks = (each: any) => {
    return (
      <>
        {each?.map((level: any, index: any) => {
          const levelColor = getLevelActiveDate(level) ? 'green' : level.levelColor;
          return (
            <Box className="MylevelsCard">
              <Box
                borderRadius="8px 8px 0 0"
                borderTop={`10px solid ${getBorderColor(levelColor, getLevelActiveDate(level))}`}
              />
              <Box>
                <Box px={2} pt={2} pb={1} display="flex" justifyContent="space-between" alignItems="center">
                  <Box width="calc(100% - 45px)">
                    <Typography color="secondary.light" variant="h6">
                      {getOrfiumLevelName(oid, selectedGroupId?.id, index + 1)}
                    </Typography>
                    <Typography variant="h5" noWrap>
                      {level.levelName}
                    </Typography>
                    {/* Level end date print */}
                    <Box height={'14px'}>
                      {level?.endDate?.value || level?.startDate?.value
                        ? getAvailabilityMessage(
                            level?.startDate?.value,
                            level?.endDate?.value,
                            'level',
                            level?.startDate?.type
                          )
                        : null}
                    </Box>
                  </Box>
                  <img
                    src={getTrophyBadge(level.hexColor, getLevelActiveDate(level))}
                    alt="Trophybadge"
                    width="35px"
                    height="35px"
                  />
                  {!level?.level && (
                    <Box>
                      <MoreVertIcon
                        color="primary"
                        className="cursor-pointer"
                        onClick={(event) => rightTopDotsClick(level)(event)}
                      />
                    </Box>
                  )}
                </Box>

                <Divider />

                {getLevelActiveDate(level) ? (
                  <Box p={2}>
                    {level.tasks.map((task: any, index: number) => {
                      return (
                        <React.Fragment key={task._id}>
                          <Box
                            gap="15px"
                            width={'100%'}
                            display="flex"
                            alignItems="center"
                            onClick={() => {
                              if (getIsTaskStarted(task?.startDate)) {
                                navigate(`/app/home/mentee/level/${level._id}/task/${task._id}`);
                              }
                            }}
                            sx={{
                              cursor: getIsTaskStarted(task?.startDate) ? 'pointer' : 'not-allowed'
                            }}
                          >
                            <img
                              src={task.taskColor === 'green' ? greencheckimg : greycheckimg}
                              alt="greencheckimg"
                              width="20px"
                              height="20px"
                            />
                            <Box flex={1} position={'relative'} width={'calc(100% - 35px)'}>
                              <Typography
                                noWrap
                                className={getIsTaskStarted(task?.startDate) ? 'cursor-pointer' : 'cursor-not-allowed'}
                                color={task.taskColor === 'green' ? 'secondary' : '#0071A9'}
                              >
                                {task.taskName}
                              </Typography>
                              {getAvailabilityMessage(task?.startDate, task?.endDate, 'task')}
                            </Box>
                          </Box>

                          {index !== level.tasks.length - 1 && (
                            <Box borderLeft="1px dotted #D9D9D9" ml="9.5px" py="10px" />
                          )}
                        </React.Fragment>
                      );
                    })}
                  </Box>
                ) : (
                  <Box p={2} mt={2} textAlign={'center'}>
                    {lockIcon({ size: '35px', color: '#68717A' })}
                    <Typography mt={1}>This module will be available {getLevelText(level)}</Typography>
                    <Link
                      color={'info.main'}
                      fontStyle={'italic'}
                      onClick={() => {
                        setLevelNumber(index + 1);
                        setLevelFullName(level?.levelName || 'No module Name');
                        setLevelDescription(level?.levelDescription || 'This module has no description');
                        handleOpenDescription();
                      }}
                    >
                      Read description of Module {index + 1}
                    </Link>
                  </Box>
                )}
              </Box>
              {!level?.level && (level?.startDate?.type === levelTypes.activeNow || level?.startDate === undefined) && (
                <Box pb={2} pl={2}>
                  <Link onClick={() => handleAddTasks(level)} color={'info.main'} variant="caption">
                    + Add Lesson
                  </Link>
                </Box>
              )}
            </Box>
          );
        })}

        {/* edit or delete modal */}
        <Popover
          id={rightTopPopover}
          open={editModalOpen}
          anchorEl={rightTopPop}
          onClose={handleClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
          <Box className="PopoverListStyle" gap="8px" onClick={() => handleEditLevel()}>
            <EditIcon />
            <Typography color="primary">Edit Module</Typography>
          </Box>
          <Box className="PopoverListStyle" onClick={() => handleDeleteLevel()} gap="8px">
            <DeleteIcon />
            <Typography color="primary">Delete Module</Typography>
          </Box>
        </Popover>
      </>
    );
  };

  const getLevelActiveDate = (level: any) => {
    if (level?.startDate?.type === levelTypes.activeNow || level?.startDate === undefined) {
      return true;
    }
    if (level?.startDate?.type === levelTypes.availableSoon) {
      return false;
    }

    if (level?.startDate?.type === levelTypes.calendarDate && currentDate >= level?.startDate?.value) {
      return true;
    }
    if (level?.startDate?.type === levelTypes.daysAfterSignup && currentDate >= level?.startDate?.value) {
      return true;
    }
    return false;
  };

  const totalObjectives = learningObjectives.length;
  const displayedObjectiveCount = objectivesNumber || totalObjectives || 0;

  const handleNextObjective = () => {
    if (!totalObjectives) return;
    setCurrentObjectiveIndex((prev) => Math.min(prev + 1, totalObjectives - 1));
  };

  const handlePrevObjective = () => {
    if (!totalObjectives) return;
    setCurrentObjectiveIndex((prev) => Math.max(prev - 1, 0));
  };

  const handleMarkObjectiveComplete = () => {
    const currentObjective = learningObjectives[currentObjectiveIndex];
    if (!currentObjective?.id || markingObjective) return;
    setCompleteModalOpen(true);
  };

  const executeMarkObjectiveComplete = async () => {
    const currentObjective = learningObjectives[currentObjectiveIndex];
    if (!currentObjective?.id || markingObjective) return;
    try {
      setMarkingObjective(true);
      const payload = {
        id: currentObjective.id,
        objective: currentObjective.objective,
        description: currentObjective.description,
        status: 'completed',
        notes: currentObjective.notes || [],
        mentors: currentObjective.mentors || []
      };
      await API.updateMenteeLearningObjectives({ objId: currentObjective.id, data: payload });
      const remainingIncomplete = learningObjectives.filter(
        (o) => o.id !== currentObjective.id && String(o.status || '').toLowerCase() !== 'completed'
      ).length;
      const allObjectivesDone = remainingIncomplete === 0;
      // Objective Score: % of the member's objectives completed after this one.
      const totalObjectives = learningObjectives.length;
      const objectiveScore = totalObjectives
        ? Math.round(((totalObjectives - remainingIncomplete) / totalObjectives) * 100)
        : undefined;
      eventTracking(events.objectiveCompleted, {
        [attributeKeys.programName]: selectedGroupId?.name || '',
        [attributeKeys.userRole]: 'Mentee',
        [attributeKeys.organizationName]: orgDisplayNameMentee || '',
        [attributeKeys.userEmail]: trackerUserEmail || '',
        [attributeKeys.objectiveScore]: objectiveScore,
        [attributeKeys.userProgramStatus]: allObjectivesDone ? 'Completed' : 'In Progress',
        objectiveId: currentObjective.id
      });
      if (allObjectivesDone) {
        eventTracking(events.allObjectivesCompleted, {
          [attributeKeys.programName]: selectedGroupId?.name || '',
          [attributeKeys.userRole]: 'Mentee',
          [attributeKeys.organizationName]: orgDisplayNameMentee || '',
          [attributeKeys.userEmail]: trackerUserEmail || '',
          [attributeKeys.objectiveScore]: 100,
          [attributeKeys.userProgramStatus]: 'Completed'
        });
      }
      queryClient.invalidateQueries({
        queryKey: [queryKeys.GET_LEARNING_OBJS, groupId]
      });
      await fetchUserLearningObjectives();
    } catch (error) {
      toast.error(_.get(error, 'response.data.message', 'Unable to update objective status'));
    } finally {
      setMarkingObjective(false);
      setCompleteModalOpen(false);
    }
  };

  const getMentorMeetings = (mentor: any) => {
    const meetings = Array.isArray(mentor?.meetings) ? mentor.meetings : [];
    const now = moment();
    const pastMeetings: any[] = [];
    const futureMeetings: any[] = [];

    meetings.forEach((meeting: any) => {
      const callDetails = meeting?.callDetails || meeting;
      const callDate = callDetails?.callDate ? moment(callDetails.callDate) : null;
      if (callDate && callDate.isValid()) {
        if (callDate.isSameOrAfter(now, 'day')) {
          futureMeetings.push(meeting);
        } else {
          pastMeetings.push(meeting);
        }
      }
    });

    return { pastMeetings, futureMeetings };
  };

  const getMentorStats = (mentor: any) => {
    const { pastMeetings, futureMeetings } = getMentorMeetings(mentor);

    const pastMeetingsCount =
      Number.isFinite(mentor?.pastMeetings) ? Math.max(mentor.pastMeetings, 0) : pastMeetings.length;
    const upcomingMeetings =
      Number.isFinite(mentor?.upcomingMeetings) ? Math.max(mentor.upcomingMeetings, 0) : futureMeetings.length;

    const messagesShared =
      mentor?.messagesShared ??
      mentor?.totalMessages ??
      mentor?.messagesCount ??
      mentor?.messageCount ??
      (Array.isArray(mentor?.messages) ? mentor.messages.length : 0) ??
      0;

    return {
      messagesShared: messagesShared || 0,
      meetingHistory: pastMeetingsCount,
      futureMeetings: upcomingMeetings
    };
  };

  const getMentorDisplayName = (mentor: any) => {
    const fullName = mentor?.name || mentor?.displayName || getName(mentor);
    if (fullName && typeof fullName === 'string') return fullName;
    return w('mentor');
  };

  const getMentorStatsSource = (mentor: any) => {
    if (!mentor || !Array.isArray(myMentorsList) || myMentorsList.length === 0) return null;
    const mentorIds = new Set(
      [
        mentor?.userId,
        mentor?.id,
        mentor?.mid,
        mentor?.mentorId,
        mentor?.communicationId
      ]
        .filter(Boolean)
        .map((value: any) => String(value))
    );
    if (mentorIds.size === 0) return null;

    return (
      myMentorsList.find((entry: any) => {
        const entryIds = [
          entry?.userId,
          entry?.id,
          entry?.mid,
          entry?.mentorId,
          entry?.communicationId
        ]
          .filter(Boolean)
          .map((value: any) => String(value));
        return entryIds.some((id: string) => mentorIds.has(id));
      }) || null
    );
  };

  /** Find matchId for this mentor from any objective in learningObjectives (same mentor may have matchId only in some objectives) */
  const getMatchIdForMentorFromObjectives = useCallback(
    (mentor: any) => {
      const mentorKey = mentor?.mentorId || mentor?.userId || mentor?.id || mentor?.mid;
      if (!mentorKey || !Array.isArray(learningObjectives)) return '';
      for (const objective of learningObjectives) {
        const list = Array.isArray(objective?.mentors) ? objective.mentors : [];
        for (const m of list) {
          const entryKey = m?.mentorId || m?.userId || m?.id || m?.mid;
          if (!entryKey || String(entryKey) !== String(mentorKey)) continue;
          const id =
            m?.matchId ?? m?.confirmMatchId ?? m?.match_id ?? m?.match?.id ?? m?.match?._id ?? m?.match?.matchId;
          if (id) return normalizeMatchId(id);
        }
      }
      return '';
    },
    [learningObjectives]
  );

  const getMentorObjectiveTitle = (mentor: any) => {
    if (!mentor || !learningObjectives.length) return '';
    const mentorId = mentor?.mid || mentor?.userId || mentor?.id || mentor?.mentorId;
    if (!mentorId) return '';
    const matchedObjective = learningObjectives.find((objective: any) => {
      return (
        Array.isArray(objective?.mentors) &&
        objective.mentors.some((eachMentor: any) => {
          const candidateId = eachMentor?.mid || eachMentor?.userId || eachMentor?.id || eachMentor?.mentorId;
          return candidateId && candidateId === mentorId;
        })
      );
    });
    return matchedObjective?.objective || '';
  };

  const renderMentorStat = (
    value: number,
    label: string,
    highlight = false,
    onClick?: () => void,
    isActive = true,
    statBg?: string,
    statValueColor?: string
  ) => {
    let IconCmp: React.ElementType | null = null;
    if (label.toLowerCase().includes('message')) IconCmp = QuestionAnswerOutlinedIcon;
    else if (label.toLowerCase().includes('history')) IconCmp = RestoreIcon;
    else if (label.toLowerCase().includes('future')) IconCmp = InsertInvitationOutlinedIcon;

    const bg = statBg ?? 'var(--Fill-background, #0F0F0F)';
    const valueColor = statValueColor ?? '#FDFDFD';

    return (
      <Box
        onClick={onClick}
        sx={{
          alignSelf: 'stretch',
          minHeight: 48,
          p: 1,
          borderRadius: '10px',
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          background: `${bg} !important`,
          cursor: onClick ? 'pointer' : 'default',
          transition: onClick ? 'transform 0.1s ease-in-out' : undefined,
          '&:hover': onClick
            ? {
                transform: 'translateY(-1px)',
                boxShadow: '0 4px 12px rgba(0,0,0,0.25)'
              }
            : undefined
        }}
      >
        <Box flex={1} display="flex" flexDirection="column" gap={0.25}>
          <Typography sx={{ color: valueColor, fontSize: 16, fontWeight: 600, lineHeight: '20px' }}>{value}</Typography>
          <Typography sx={{ color: 'var(--Text-text-tertiary, #B6B6B6)', fontSize: 12, fontWeight: 600, lineHeight: '16px' }}>{label}</Typography>
        </Box>
        <Box
          sx={{
            width: highlight ? 36 : 28,
            height: highlight ? 36 : 28,
            borderRadius: '999px',
            background: highlight
              ? 'linear-gradient(180deg, #F79420 0%, #F15A26 100%)'
              : 'var(--Fill-Button-button-gray, #1C1C1C)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          {IconCmp ? (
            <IconCmp sx={{ color: '#FDFDFD', fontSize: highlight ? 20 : 16 }} />
          ) : (
            <Box
              sx={{
                width: 20,
                height: 20,
                border: `2px solid ${highlight ? '#FDFDFD' : '#FDFDFD'}`,
                borderRadius: highlight ? '4px' : '6px'
              }}
            />
          )}
        </Box>
      </Box>
    );
  };

  const renderMentorCard = (mentor: any, index: number, isActive = true) => {
    const mentorName = getMentorDisplayName(mentor);
    const [firstName, ...restName] = mentorName.split(' ');
    const lastName = restName.join(' ');
    const avatar = mentor?.image || mentor?.headshot;
    const statsSource = getMentorStatsSource(mentor);
    const stats = getMentorStats(statsSource || mentor);
    const mentorKey = mentor?.mentorId || mentor?.userId || mentor?.id || mentor?.mid;
    const mentorFromList = Array.isArray(myMentorsList)
      ? myMentorsList.find((entry: any) => {
          const entryKey = entry?.mentorId || entry?.userId || entry?.id || entry?.mid;
          return entryKey && mentorKey && String(entryKey) === String(mentorKey);
        })
      : null;
    const rawMatchId =
      mentorFromList?.matchId ??
      mentorFromList?.confirmMatchId ??
      mentor?.matchId ??
      mentor?.confirmMatchId ??
      mentor?.match_id ??
      (mentor?.match && (mentor.match.id ?? mentor.match._id ?? mentor.match.matchId)) ??
      getMatchIdForMentorFromObjectives(mentor) ??
      '';
    const matchId = normalizeMatchId(rawMatchId);
    if (matchId) fetchMatchProfileIfNeeded(matchId);
    const matchProfile = matchId ? matchProfilesById[matchId] : null;
    const currentObjId = mentor?.objectiveId ?? '';
    const meetingHistoryApi = matchProfile?.meetingHistory;
    const pastForObjective = (meetingHistoryApi?.past ?? []).filter(
      (m: any) => m?.objective != null && String(m.objective) === String(currentObjId)
    );
    const upcomingForObjective = (meetingHistoryApi?.upcoming ?? []).filter(
      (m: any) => m?.objective != null && String(m.objective) === String(currentObjId)
    );
    const useMatchProfileForCounts =
      matchProfile && meetingHistoryApi && currentObjId;
    const matchStats = {
      messagesShared:
        statsSource?.messagesShared ??
        mentor?.messagesShared ??
        matchProfile?.messagesShared ??
        matchProfile?.messagedShared ??
        stats.messagesShared,
      meetingHistory: useMatchProfileForCounts
        ? pastForObjective.length
        : (Number.isFinite(statsSource?.pastMeetings) ? Math.max(statsSource.pastMeetings, 0) : undefined) ??
          (Number.isFinite(mentor?.pastMeetings) ? Math.max(mentor.pastMeetings, 0) : undefined) ??
          matchProfile?.pastCall ??
          stats.meetingHistory,
      futureMeetings: useMatchProfileForCounts
        ? upcomingForObjective.length
        : (Number.isFinite(statsSource?.upcomingMeetings) ? Math.max(statsSource.upcomingMeetings, 0) : undefined) ??
          (Number.isFinite(mentor?.upcomingMeetings) ? Math.max(mentor.upcomingMeetings, 0) : undefined) ??
          matchProfile?.futureCall ??
          stats.futureMeetings
    };

    const textPrimary = isActive ? '#FDFDFD' : '#868686';
    const textTertiary = isActive ? '#B6B6B6' : '#6B6B6B';
    const statBg = isActive ? 'var(--Fill-background, #0F0F0F)' : 'rgba(255,255,255,0.04)';
    const statValueColor = isActive ? '#FDFDFD' : textTertiary;

    return (
      <Box
        key={mentor?.mid || mentor?.userId || mentor?.id || index}
        sx={{
          width: MENTOR_CARD_WIDTH,
          minHeight: MENTOR_CARD_HEIGHT,
          p: 2,
          borderRadius: '6px',
          outline: `1px solid ${isActive ? 'var(--Stroke-Card-card-highlight, #FDFDFD)' : 'var(--Stroke-Border-border-dim, #2A2A2A)'}`,
          outlineOffset: '-1px',
          background: isActive ? 'var(--Fill-Card-card-highlight, #1C1C1C)' : 'transparent',
          display: 'flex',
          flexDirection: 'column',
          gap: 2.5
        }}
      >
        <Box display="flex" alignItems="center" gap={1} width="100%">
          <Box
            sx={{
              width: 40,
              height: 40,
              borderRadius: '50%',
              overflow: 'hidden',
              background: '#2A2A2A',
              flexShrink: 0,
              opacity: isActive ? 1 : 0.5
            }}
            onClick={() => moveToUsercommunityProfile(mentor?.userId)}
          >
            {avatar ? (
              <Box
                component="img"
                src={avatar}
                alt={mentorName}
                sx={{ width: '100%', height: '100%', objectFit: 'cover' }}
              />
            ) : (
              <Box
                sx={{
                  width: '100%',
                  height: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: '#fff',
                  fontWeight: 700,
                  fontSize: 14
                }}
              >
                {mentorName.charAt(0)}
              </Box>
            )}
          </Box>
          <Box flex={1} display="flex" flexDirection="column" gap={0.25} minWidth={0}>
            <Typography sx={{ color: textTertiary, fontSize: 9, fontWeight: 700, lineHeight: '12px' }}>
              {`${w('mentor')} ${index + 1}`}
            </Typography>
            <Box display="flex" gap={0.25} alignItems="center" flexWrap="wrap">
              <Typography sx={{ color: textPrimary, fontSize: 16, fontWeight: 600, lineHeight: '20px' }} noWrap>
                {firstName}
              </Typography>
              {lastName && (
                <Typography sx={{ color: textPrimary, fontSize: 16, fontWeight: 600, lineHeight: '20px' }} noWrap>
                  {lastName}
                </Typography>
              )}
            </Box>
          </Box>
          <Box
            sx={{
              width: 20,
              height: 20,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#FDFDFD'
            }}
            onClick={(e) => handleOpenMentorMenu(e as any, mentor)}
          >
            <MoreVertIcon sx={{ fontSize: 18 }} />
          </Box>
        </Box>

        <Stack spacing={1} width="100%">
          {renderMentorStat(
            matchStats.messagesShared,
            'Messages Shared',
            true,
            () => handleViewMentorProfile(mentor),
            isActive,
            statBg,
            statValueColor
          )}
          {renderMentorStat(
            matchStats.meetingHistory,
            'Meeting History',
            false,
            () => handleOpenMeetingModal(mentor, 'history', mentor?.objectiveId),
            isActive,
            statBg,
            statValueColor
          )}
          {renderMentorStat(
            matchStats.futureMeetings,
            'Future Meetings',
            false,
            () => handleOpenMeetingModal(mentor, 'future', mentor?.objectiveId),
            isActive,
            statBg,
            statValueColor
          )}
        </Stack>
      </Box>
    );
  };

  const objectiveMentorsMap = useMemo(() => {
    const map: Record<string, any[]> = {};
    (learningObjectives || []).forEach((objective: any, idx: number) => {
      const objectiveId =
        getObjectiveIdentifier(objective) ||
        objective?.id ||
        objective?._id ||
        objective?.objectiveId ||
        objective?.objective ||
        `${objective?.objective || 'objective'}_${idx}`;
      if (!objectiveId) return;
      const mentorsList = Array.isArray(objective?.mentors) ? objective.mentors : [];
      map[String(objectiveId)] = mentorsList.map((mentor: any) => ({
        ...mentor,
        objectiveId: String(objectiveId),
        objective: objective?.objective || objective?.name || mentor?.objective || mentor?.objectiveName || 'Objective'
      }));
    });
    return map;
  }, [learningObjectives]);

  const renderMentorshipLayout = () => {
    const currentObjective = learningObjectives[currentObjectiveIndex];
    const currentObjectiveId =
      getObjectiveIdentifier(currentObjective) ||
      currentObjective?.id ||
      currentObjective?._id ||
      currentObjective?.objective;
    const mentorsForObjective = currentObjectiveId
      ? objectiveMentorsMap[String(currentObjectiveId)] || []
      : currentObjective?.mentors || [];
    const mentorCards = [...(mentorsForObjective || []), { isAddCard: true }];
    const totalMentorCards = mentorCards.length;
    const mentorPrevDisabled = mentorCardIndex <= 0;
    const isOnAddCard = mentorCards[mentorCardIndex]?.isAddCard;
    const mentorNextDisabled = !isOnAddCard && mentorCardIndex >= totalMentorCards - 1;
    const objectiveLabel = totalObjectives ? `Objective ${currentObjectiveIndex + 1}` : 'Objective';
    const isPrevDisabled = currentObjectiveIndex <= 0;
    const isNextDisabled = currentObjectiveIndex >= Math.max(totalObjectives - 1, 0);

    if (userObjectivesLoading) {
      return (
        <Box p={3}>
          <MySkeleton variant="rounded" height={200} />
        </Box>
      );
    }

    if (!totalObjectives) {
      return (
        <Box p={3} bgcolor="var(--Fill-Table-table-highlight, #151515)" borderRadius={1.25}>
          <Typography variant="h5" color="secondary" mb={1}>
            No objectives found
          </Typography>
          <Typography color="text.secondary">
            Add your first objective to start matching with {w('mentor', { plural: true, lower: true })}.
          </Typography>
        </Box>
      );
    }

    return (
      <Box
        position="relative"
        p={2.5}
        borderRadius="5px"
        bgcolor="var(--Fill-Table-table-highlight, #151515)"
        overflow="hidden"
        sx={{ border: '1px solid var(--Stroke-Carousel-button, #2A2A2A)', height: '100%' }}
      >
        <Stack direction={{ xs: 'column', md: 'row' }} spacing={1.75} alignItems="center">
          <Box flex={1} display="flex" flexDirection="column" gap={0.75} width="100%">
            <Box display="flex" alignItems="center" gap={1.25}>
              <Typography fontSize={14} sx={{ color: 'white' }} fontWeight={400} lineHeight="20px">
                {displayedObjectiveCount ? `${objectiveLabel} of ${displayedObjectiveCount}` : objectiveLabel}
              </Typography>
              {currentObjective?.status === 'completed' && (
                <Box display="flex" alignItems="center" gap={0.5}>
                  <CheckOutlinedIcon
                    sx={{
                      width: 16,
                      height: 16,
                      color: 'var(--UI-Success, #00972D)',
                      border: '1.5px solid var(--UI-Success, #00972D)',
                      borderRadius: '4px',
                      p: 0.3,
                      boxSizing: 'border-box'
                    }}
                  />
                  <Typography fontSize={12} fontWeight={600} color="var(--UI-Success, #00972D)" lineHeight="17px">
                    Completed
                  </Typography>
                </Box>
              )}
            </Box>
            <Typography
              fontSize={24}
              fontWeight={600}
              color={` ${currentObjective?.status === 'completed' ? '#00972D' : '#F79420'}`}
              textTransform="capitalize"
              lineHeight="32px"
              noWrap
            >
              {currentObjective?.objective || 'Add your objective'}
            </Typography>
          </Box>

          <Box
            sx={{
              width: { xs: '100%', md: 384 },
              p: 1.75,
              background: 'var(--Fill-Card-card-goal-bg, #0F0F0F)',
              borderRadius: '5px',
              display: 'flex',
              alignItems: 'flex-start',
              gap: 1.5
            }}
          >
            <FlagOutlinedIcon
              sx={{
                color: 'var(--Stroke-icon-highlight, #FDFDFD)',
                width: 18,
                height: 18,
                mt: 0.25
              }}
            />
            <Typography fontSize={12} fontWeight={700} sx={{ color: 'white' }} lineHeight="18px">
              Your goal is to message your {w('mentor', { lower: true })}(s), and complete at least one meeting with
              them for each Objective
            </Typography>
          </Box>
        </Stack>

        <Box mt={1.5} display="flex" flexDirection="column" gap={1.5}>
          <Typography fontSize={20} fontWeight={600} sx={{ color: 'var(--Text-text-tertiary, #B6B6B6)' }}>
            My {w('mentor', { plural: true })} for this Objective:
          </Typography>
          <Box
            sx={{
              position: 'relative',
              pt: 2,
              pb: 4,
              minHeight: MENTOR_CARD_HEIGHT
            }}
          >
            <Box
              ref={bindMentorSlider}
              sx={{
                width: '100%',
                minWidth: 0,
                overflowX: 'auto',
                overflowY: 'hidden',
                display: 'block',
                scrollSnapType: 'x mandatory',
                '&::-webkit-scrollbar': { display: 'none' },
                scrollbarWidth: 'none'
              }}
            >
              <Box
                sx={{
                  display: 'inline-flex',
                  gap: MENTOR_CARD_GAP,
                  px: `calc(50% - ${MENTOR_CARD_WIDTH / 2}px)`,
                  py: 1,
                  boxSizing: 'content-box',
                  minWidth: 'min-content'
                }}
              >
                {mentorCards.length ? (
                  mentorCards.map((mentor, index) => {
                    const isActiveCard = index === mentorCardIndex;
                    return (
                      <Box
                        key={mentor?.mid || mentor?.userId || mentor?.id || `mentor-${index}`}
                        sx={{
                          width: MENTOR_CARD_WIDTH,
                          flex: '0 0 auto',
                          scrollSnapAlign: 'center',
                          position: 'relative'
                        }}
                        ref={(el) => {
                          mentorCardRefs.current[index] = el as HTMLDivElement | null;
                        }}
                      >
                        {mentor?.isAddCard ? (
                          <Box
                            onClick={() => handleRecruitModalOpen(true)}
                            sx={{
                              cursor: 'pointer',
                              width: MENTOR_CARD_WIDTH,
                              minHeight: MENTOR_CARD_HEIGHT,
                              p: 2,
                              borderRadius: '6px',
                              outline: '1px solid var(--Stroke-Border-border-dim, #2A2A2A)',
                              outlineOffset: '-1px',
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'center',
                              justifyContent: 'center',
                              gap: 2.5,
                              textAlign: 'center',
                              background: 'transparent'
                            }}
                          >
                            <Typography fontSize={18} fontWeight={600} sx={{ color: 'var(--Text-text-secondary, #868686)' }}>
                              Add {w('mentor')}
                            </Typography>
                            <Box
                              sx={{
                                width: 28,
                                height: 28,
                                borderRadius: '14px',
                                background: 'var(--Fill-Button-button-gray, #1C1C1C)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                border: '1px solid #2A2A2A'
                              }}
                            >
                              <AddIcon sx={{ width: 16, height: 16, color: '#FDFDFD' }} />
                            </Box>
                          </Box>
                        ) : (
                          renderMentorCard(mentor, index, isActiveCard)
                        )}
                      </Box>
                    );
                  })
                ) : (
                  <Box
                    sx={{
                      width: MENTOR_CARD_WIDTH,
                      minHeight: 200,
                      borderRadius: '6px',
                      border: '1px dashed #2A2A2A',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: 'text.primary',
                      textAlign: 'center',
                      px: 2
                    }}
                  >
                    No {w('mentor', { plural: true, lower: true })} yet. Add{' '}
                    {w('mentor', { lower: true, article: true })} to get started.
                  </Box>
                )}
              </Box>
            </Box>
            <IconButton
              disabled={mentorPrevDisabled}
              onClick={() => scrollMentorToIndex(Math.max(0, mentorCardIndex - 1))}
              sx={{
                position: 'absolute',
                left: `calc(50% - ${MENTOR_CARD_WIDTH / 2 + 48 + 4}px)`,
                top: '50%',
                transform: 'translateY(-50%)',
                zIndex: 1,
                width: 48,
                height: 96,
                background: mentorPrevDisabled
                  ? 'var(--Fill-Carousel-button-disabled, rgba(0, 0, 0, 0.10))'
                  : 'var(--Fill-Carousel-button-default/50, rgba(0, 0, 0, 0.50))',
                borderRadius: '8px 0 0 8px',
                border: '1px solid var(--Stroke-Carousel-button, #2A2A2A)',
                borderRight: 'none',
                '&:hover': mentorPrevDisabled ? {} : { background: 'rgba(0, 0, 0, 0.65)' },
                '&.Mui-disabled': { borderColor: '#2A2A2A' }
              }}
            >
              <ArrowBackIosNewOutlinedIcon fontSize="small" sx={{ color: mentorPrevDisabled ? '#444' : '#FDFDFD' }} />
            </IconButton>
            <IconButton
              disabled={mentorNextDisabled}
              onClick={() => {
                if (mentorCardIndex >= totalMentorCards - 1 && mentorCards[totalMentorCards - 1]?.isAddCard) {
                  handleRecruitModalOpen(true);
                  return;
                }
                scrollMentorToIndex(Math.min(mentorCardIndex + 1, totalMentorCards - 1));
              }}
              sx={{
                position: 'absolute',
                right: `calc(50% - ${MENTOR_CARD_WIDTH / 2 + 48 + 4}px)`,
                top: '50%',
                transform: 'translateY(-50%)',
                zIndex: 1,
                width: 48,
                height: 96,
                background: mentorNextDisabled
                  ? 'var(--Fill-Carousel-button-disabled, rgba(0, 0, 0, 0.10))'
                  : 'var(--Fill-Carousel-button-default/50, rgba(0, 0, 0, 0.50))',
                borderRadius: '0 8px 8px 0',
                border: '1px solid var(--Stroke-Carousel-button, #2A2A2A)',
                borderLeft: 'none',
                '&:hover': mentorNextDisabled ? {} : { background: 'rgba(0, 0, 0, 0.65)' }
              }}
            >
              {mentorCards[mentorCardIndex]?.isAddCard ? (
                <AddIcon fontSize="small" sx={{ color: '#FDFDFD' }} />
              ) : (
                <ArrowForwardIosOutlinedIcon fontSize="small" sx={{ color: '#FDFDFD' }} />
              )}
            </IconButton>
          </Box>
        </Box>

        <Box
          sx={{
            position: 'absolute',
            bottom: 24,
            left: '50%',
            transform: 'translateX(-50%)',
            minHeight: 64,
            background: 'var(--Fill-tooltip-dim, #2A2A2A)',
            boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.55)',
            borderRadius: '16px',
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            px: '14px',
            py: '12px',
            maxWidth: 700
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: '5px',
              borderRadius: '6px',
              cursor: isPrevDisabled ? 'not-allowed' : 'pointer',
              color: 'var(--Text-text-primary, #FDFDFD)',
              opacity: isPrevDisabled ? 0.5 : 1
            }}
            onClick={() => {
              if (isPrevDisabled) return;
              handlePrevObjective();
            }}
          >
            <ArrowBackIcon sx={{ width: 18, height: 18, color: 'var(--Stroke-icon-highlight, #FDFDFD)' }} />
            <Typography fontSize={12} fontWeight={600} color="var(--Text-text-primary, #FDFDFD)">
              Last Objective
            </Typography>
          </Box>

          <Divider
            orientation="vertical"
            flexItem
            sx={{ borderColor: 'var(--Fill-Transparent-trans-contrast-1, rgba(255, 255, 255, 0.10))' }}
          />

          {currentObjective?.status === 'completed' ? (
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '5px',
                px: '14px',
                py: '10px',
                borderRadius: '6px',
                background: 'var(--Fill-Button-button-basic-disable, rgba(0, 0, 0, 0.20))',
                boxShadow: 'inset 0 0 0 1px #2A2A2A',
                cursor: 'default'
              }}
            >
              <Typography
                fontSize={13}
                fontWeight={500}
                color="var(--Stroke-Button-button-basic-disabled, #565656)"
                lineHeight="19.5px"
              >
                Objective Completed
              </Typography>
            </Box>
          ) : (
            <Box
              onClick={handleMarkObjectiveComplete}
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '5px',
                px: '14px',
                py: '10px',
                borderRadius: '6px',
                ...(!currentObjective?.id || markingObjective
                  ? { ...buttonDisabledSx, cursor: 'not-allowed' }
                  : {
                      background:
                        'linear-gradient(180deg, var(--orange-500, #F79420) 0%, var(--orange-700, #F15A26) 100%)',
                      color: 'var(--Stroke-Button-button-cta-default, #FDFDFD)',
                      cursor: 'pointer'
                    })
              }}
            >
              <Typography fontSize={13} fontWeight={600} color="inherit" lineHeight="19.5px">
                {markingObjective ? 'Completing...' : 'Mark Objective Complete'}
              </Typography>
            </Box>
          )}

          <Divider
            orientation="vertical"
            flexItem
            sx={{ borderColor: 'var(--Fill-Transparent-trans-contrast-1, rgba(255, 255, 255, 0.10))' }}
          />

          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: '5px',
              borderRadius: '6px',
              cursor: isNextDisabled ? 'not-allowed' : 'pointer',
              color: 'var(--Text-text-primary, #FDFDFD)',
              opacity: isNextDisabled ? 0.5 : 1
            }}
            onClick={() => {
              if (isNextDisabled) return;
              handleNextObjective();
            }}
          >
            <Typography fontSize={12} fontWeight={600} color="var(--Text-text-primary, #FDFDFD)">
              Next Objective
            </Typography>
            <ArrowForwardIcon sx={{ width: 18, height: 18, color: 'var(--Stroke-icon-highlight, #FDFDFD)' }} />
          </Box>
        </Box>

      </Box>
    );
  };

  const meetingFilters = useMemo(() => meetingColor(), []);
  const { type: activeModalType, mentor: activeModalMentor, objectiveId: activeModalObjectiveId } = activeMeetingModal;
  const activeMeetingGroups = activeModalMentor
    ? getMentorMeetings(activeModalMentor)
    : { pastMeetings: [], futureMeetings: [] };
  const meetingHistoryPast = meetingHistoryFromApi?.past ?? activeMeetingGroups.pastMeetings;
  const meetingHistoryUpcoming = meetingHistoryFromApi?.upcoming ?? activeMeetingGroups.futureMeetings;
  const meetingHistoryCanceled = meetingHistoryFromApi?.canceled ?? [];
  const filterByObjective = (list: any[]) => {
    if (!activeModalObjectiveId || !Array.isArray(list)) return list;
    return list.filter((m: any) => m?.objective != null && String(m.objective) === String(activeModalObjectiveId));
  };
  const pastFiltered = filterByObjective(meetingHistoryPast);
  const upcomingFiltered = filterByObjective(meetingHistoryUpcoming);
  const canceledFiltered = filterByObjective(meetingHistoryCanceled);
  const meetingsToShow =
    activeModalType === 'future'
      ? upcomingFiltered
      : activeModalType === 'history'
      ? [...pastFiltered, ...canceledFiltered]
      : [];
  /** Map meetingId -> enriched meeting from UserLearningObjectives (data[].mentors[].meetings[]) for review/rating/feedback */
  const meetingDetailsByMeetingId = useMemo(() => {
    const map: Record<string, any> = {};
    (userLearningObjectives || []).forEach((obj: any) => {
      (obj.mentors || []).forEach((m: any) => {
        (m.meetings || []).forEach((meeting: any) => {
          const id = meeting?.meetingId ?? meeting?.callId ?? meeting?._id;
          if (id) map[String(id)] = { ...meeting, mentorInfo: m };
        });
      });
    });
    return map;
  }, [userLearningObjectives]);
  const activeModalObjectiveTitle =
    activeModalObjectiveId && Array.isArray(learningObjectives)
      ? ((learningObjectives.find(
          (o: any) =>
            String(getObjectiveIdentifier(o) ?? o?.id ?? o?._id ?? o?.objective) === String(activeModalObjectiveId)
        ) as any)?.objective ?? (learningObjectives.find((o: any) => o?.id === activeModalObjectiveId) as any)?.name) ?? activeModalMentor?.objective ?? 'Learning Objective'
      : getMentorObjectiveTitle(activeModalMentor) || 'Learning Objective';
  const mentorDisplayName = activeModalMentor ? getMentorDisplayName(activeModalMentor) : w('mentor');
  const meetingModalTitle =
    activeModalType === 'future'
      ? `Future Meetings with ${mentorDisplayName}`
      : activeModalType === 'history'
      ? `Meeting History with ${mentorDisplayName}`
      : '';
  const meetingEmptyMessage =
    activeModalType === 'future'
      ? 'No upcoming meetings scheduled.'
      : activeModalType === 'history'
      ? 'No previous meetings logged yet.'
      : '';
  const objectiveTitle = activeModalObjectiveTitle;
  const getCallDateParts = (callRowData: any) => {
    if (!callRowData?.callDate || !callRowData?.callTime || !timezone) {
      return { month: '', day: '', weekday: '' };
    }
    const locale = 'en-US';
    const dateTime = timeZonWiseDateTime(callRowData.callDate.toString(), callRowData.callTime.toString(), timezone);
    return {
      month: dateTime.toLocaleString(locale, { month: 'short' }),
      day: dateTime.getDate().toString(),
      weekday: dateTime.toLocaleString(locale, { weekday: 'short' })
    };
  };

  const getMeetingTimeLabel = (callRowData: any) => {
    if (!callRowData?.callDate || !callRowData?.callTime || !timezone) {
      return '';
    }
    return `${timeZoneWiseTime(
      callRowData.callDate.toString(),
      callRowData.callTime.toString(),
      timezone
    ).toLowerCase()} (${timeZoneAbbreviation(timezone)})`;
  };

  const callWithTitle = (callRow: any) => {
    let reviewModalTitle = '';
    if (callRow?.chatType === 'Chats') {
      reviewModalTitle =
        currentUserId === callRow?.callBookedWith?.id
          ? callRow?.callBookedBy?.displayName
          : callRow?.callBookedWith?.displayName;
    } else {
      reviewModalTitle = callRow?.callBookedWith?.name;
    }
    return reviewModalTitle;
  };

  const getCallStatusData = (callRowData: any) => {
    const matchingParticipant = callRowData?.participantsUser?.find((user: any) => user.mid === currentUserId);
    const joinedParticipantsCount =
      callRowData?.participantsUser?.filter((participant: any) => participant.isCallJoined)?.length || 0;
    const isBookerJoined =
      callRowData?.participantsUser?.some((participant: any) => participant.mid === callRowData?.callBookedBy?.id) ||
      false;
    const callTypeData = checkCallType(
      callRowData?.callStatus,
      callRowData?.callDate,
      callRowData?.callTime,
      callRowData?.callTimeInterval,
      matchingParticipant?.callRejectStatus,
      joinedParticipantsCount,
      isBookerJoined
    );
    const filterMeta =
      meetingFilters.find((meeting) => meeting.color === callTypeData?.color_code) ||
      meetingFilters.find((meeting) => meeting.title === callTypeData?.title) ||
      meetingFilters[0];
    return {
      color: callTypeData?.color_code || filterMeta?.color || '#00972D'
    };
  };

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    // Guided Masterclass (hybrid: masterclass&mentorship) is masterclass-led
    // for the learner — it must follow the masterclass redirect into the
    // level/task flow, NOT fall through to the mentorship objectives layout.
    // `isMentorship` is true for hybrids too, so gate on pure mentorship only.
    if (isMentorship && !isHybrid) return;
    if (!Array.isArray(taskData) || taskData.length === 0) return;

    // eslint-disable-next-line prefer-destructuring
    const program = taskData[0];
    if (!program?.levels?.length) return;

    const findFirstTaskByColor = (color: string) => {
      for (const level of program.levels) {
        const levelId = level._id;
        const tasks = level.tasks || [];
        const task = tasks.find((t: any) => t.taskColor === color);
        if (task) {
          return { levelId, taskId: task._id };
        }
      }
      return null;
    };

    const firstGrey = findFirstTaskByColor('grey');
    if (firstGrey) {
      const url = `/app/home/mentee/level/${firstGrey.levelId}/task/${firstGrey.taskId}`;
      navigate(url);
      return;
    }

    const allGreen =
      program.levels.length > 0 &&
      program.levels.every((level: any) => {
        const tasks = level.tasks || [];
        return tasks.length > 0 && tasks.every((task: any) => task.taskColor === 'green');
      });

    if (allGreen) {
      const firstGreen = findFirstTaskByColor('green');
      if (firstGreen) {
        const url = `/app/home/mentee/level/${firstGreen.levelId}/task/${firstGreen.taskId}`;
        navigate(url);
      }
    }
  }, [isMentorship, isHybrid, taskData, navigate]);

  // Guided Masterclass is rendered as a masterclass for learners — only a
  // PURE mentorship program shows the objectives/mentors layout. Hybrids fall
  // into the masterclass branch, which redirects to the level/task flow.
  const isPureMentorship = isMentorship && !isHybrid;
  const showCardsLoading = isPureMentorship && (loader || !cardsStatsReady);

  // The masterclass branch below is only a spinner: it relies on the redirect
  // effect above to leave for the first lesson. A program with no published
  // levels (still in Design) gives that effect nothing to navigate to, so
  // loaded-but-empty must render a real message instead of spinning forever.
  const fetchedProgram = Array.isArray(newData?.data?.data) ? newData?.data?.data[0] : undefined;
  const masterclassNotReady = !taskLoading && !isFetching && !fetchedProgram?.levels?.length;

  return (
    <>
      <Box className="bodyBoxMentee">
        {!isPureMentorship ? (
          <Box
            sx={{
              width: '100%',
              minHeight: '60vh',
              display: 'flex',
              flexDirection: 'column',
              gap: 2,
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            {masterclassNotReady ? (
              <>
                <Typography sx={{ color: '#FDFDFD', fontSize: '20px', fontWeight: 600 }}>
                  This program isn&apos;t ready yet
                </Typography>
                <Typography sx={{ color: '#9BA5B7', fontSize: '14px', textAlign: 'center', maxWidth: '420px' }}>
                  This program is still being built. Check back once your admin has published this program.
                </Typography>
                <Button
                  variant="outlined"
                  onClick={() => navigate('/app/home/user')}
                  sx={{
                    mt: 1,
                    color: '#FDFDFD',
                    background: '#1C1C1C',
                    borderColor: '#2A2A2A',
                    textTransform: 'none',
                    '&:hover': { background: '#262626', borderColor: '#2A2A2A' }
                  }}
                >
                  Back to My Programs
                </Button>
              </>
            ) : (
              <Box
                aria-busy="true"
                sx={{ width: '100%', maxWidth: 900, display: 'flex', flexDirection: 'column', gap: '16px' }}
              >
                <Bone height={28} width="40%" />
                <Bone height={160} radius="8px" />
                <Bone height={160} radius="8px" />
              </Box>
            )}
          </Box>
        ) : showCardsLoading ? (
          <Box
            sx={{
              width: '100%',
              minHeight: '60vh',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <Box
              aria-busy="true"
              sx={{ width: '100%', maxWidth: 900, display: 'flex', flexDirection: 'column', gap: '16px' }}
            >
              <Bone height={28} width="40%" />
              <Bone height={160} radius="8px" />
              <Bone height={160} radius="8px" />
            </Box>
          </Box>
        ) : (
          renderMentorshipLayout()
        )}
      </Box>

      <Popover
        open={Boolean(mentorMenuAnchor)}
        anchorEl={mentorMenuAnchor}
        onClose={handleCloseMentorMenu}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 0,
            background: 'var(--Fill-background, #0F0F0F)',
            borderRadius: '5px',
            outline: '1px solid var(--Stroke-Border-border, #444444)',
            outlineOffset: '-1px'
          }
        }}
      >
        <Box
          sx={{
            width: 200,
            p: '10px 15px',
            display: 'flex',
            flexDirection: 'column',
            gap: '7px'
          }}
        >
          <Box
            onClick={() => handleViewMentorProfile(mentorMenuData)}
            sx={{
              borderRadius: '6px',
              display: 'inline-flex',
              alignItems: 'center',
              gap: '5px',
              cursor: 'pointer'
            }}
          >
            <Typography sx={{ color: 'var(--Text-text-primary, #FDFDFD)', fontSize: 12, fontWeight: 600 }}>
              View {w('mentor')} Profile
            </Typography>
          </Box>
          <Box
            onClick={handleCancelMatchClick}
            sx={{
              borderRadius: '6px',
              display: 'inline-flex',
              alignItems: 'center',
              gap: '5px',
              cursor: 'pointer'
            }}
          >
            <Typography sx={{ color: 'var(--UI-Error, #FF0000)', fontSize: 12, fontWeight: 600 }}>
              Cancel Match
            </Typography>
          </Box>
        </Box>
      </Popover>

      <Modal open={completeModalOpen} onClose={() => (!markingObjective ? setCompleteModalOpen(false) : null)}>
        <Box
          sx={{
            width: 550,
            bgcolor: 'var(--Fill-Modal-background, #0F0F0F)',
            borderRadius: 2,
            outline: '1px solid var(--Stroke-Modal-border, #444444)',
            outlineOffset: '-1px',
            overflow: 'hidden',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)'
          }}
        >
          <Box
            sx={{
              width: '100%',
              px: 3,
              pr: 5,
              py: 2.5,
              borderBottom: '1px solid var(--Stroke-Border-border-dim, #2A2A2A)',
              display: 'flex',
              alignItems: 'center',
              gap: 2.5,
              position: 'relative'
            }}
          >
            <Typography sx={{ color: '#FDFDFD', fontSize: 18, fontWeight: 700, flex: 1 }}>
              Complete Objective
            </Typography>
            <IconButton
              size="small"
              onClick={() => (!markingObjective ? setCompleteModalOpen(false) : null)}
              sx={{ position: 'absolute', right: 18, top: 18, color: '#FDFDFD' }}
            >
              <Box
                sx={{
                  width: 11,
                  height: 11,
                  outline: '2px solid var(--Stroke-icon-highlight, #FDFDFD)',
                  outlineOffset: '-1px'
                }}
              />
            </IconButton>
          </Box>
          <Box
            sx={{
              p: 3,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 3.75
            }}
          >
            <Typography
              sx={{
                color: 'var(--Text-text-secondary, #B6B6B6)',
                fontSize: 14,
                fontWeight: 500,
                lineHeight: '19.88px',
                textAlign: 'center'
              }}
            >
              Objectives are a fundamental part of your program. Make sure you’ve completed{' '}
              <Typography component="span" sx={{ fontWeight: 700, color: 'var(--Text-text-secondary, #B6B6B6)' }}>
                at least 1 Mentorship Program meeting
              </Typography>{' '}
              on this objective before you proceed to mark it as complete.
            </Typography>
            <Box display="flex" gap={1.5} width="100%" justifyContent="center">
              <Button
                fullWidth
                onClick={() => setCompleteModalOpen(false)}
                sx={{
                  px: 1.75,
                  py: 1.25,
                  background: 'var(--Fill-Button-button-basic-default, #1C1C1C)',
                  border: '1px solid var(--Stroke-Border-border-dim, #2A2A2A)',
                  borderRadius: '6px',
                  color: 'var(--Stroke-Button-button-basic-default, #FDFDFD)',
                  fontSize: 13,
                  fontWeight: 500,
                  textTransform: 'none'
                }}
              >
                Cancel
              </Button>
              <Button
                fullWidth
                disabled={markingObjective}
                onClick={executeMarkObjectiveComplete}
                sx={{
                  px: 1.75,
                  py: 1.25,
                  background: 'linear-gradient(180deg, #F79420 0%, #F15A26 100%)',
                  borderRadius: '6px',
                  color: 'var(--Stroke-Button-button-cta-default, #FDFDFD)',
                  fontSize: 13,
                  fontWeight: 600,
                  textTransform: 'none',
                  '&.Mui-disabled': buttonDisabledSx
                }}
              >
                {markingObjective ? 'Completing...' : 'Mark as Complete'}
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>

      <Modal open={cancelMatchModalOpen} onClose={() => setCancelMatchModalOpen(false)}>
        <Box
          sx={{
            width: 550,
            bgcolor: 'var(--Fill-Modal-background, #0F0F0F)',
            borderRadius: 2,
            outline: '1px solid var(--Stroke-Modal-border, #444444)',
            outlineOffset: '-1px',
            overflow: 'hidden',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)'
          }}
        >
          <Box
            sx={{
              width: '100%',
              px: 3,
              pr: 5,
              py: 2.5,
              borderBottom: '1px solid var(--Stroke-Border-border-dim, #2A2A2A)',
              display: 'flex',
              alignItems: 'center',
              gap: 2.5,
              position: 'relative'
            }}
          >
            <Typography sx={{ color: '#FDFDFD', fontSize: 18, fontWeight: 700, flex: 1 }}>Cancel Match?</Typography>
            <IconButton
              size="small"
              onClick={() => setCancelMatchModalOpen(false)}
              sx={{ position: 'absolute', right: 18, top: 18, color: '#FDFDFD' }}
            >
              <Box
                sx={{
                  width: 11,
                  height: 11,
                  outline: '2px solid var(--Stroke-icon-highlight, #FDFDFD)',
                  outlineOffset: '-1px'
                }}
              />
            </IconButton>
          </Box>
          <Box
            sx={{
              p: 3,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 3.75
            }}
          >
            <Typography
              sx={{
                color: 'var(--Text-text-secondary, #B6B6B6)',
                fontSize: 14,
                fontWeight: 500,
                lineHeight: '19.88px',
                textAlign: 'center'
              }}
            >
              Are you sure you want to cancel the match with your tutor?
            </Typography>
            <Box display="flex" gap={1.5} width="100%" justifyContent="center">
              <Button
                fullWidth
                onClick={() => setCancelMatchModalOpen(false)}
                sx={{
                  px: 1.75,
                  py: 1.25,
                  background: 'var(--Fill-Button-button-basic-default, #1C1C1C)',
                  border: '1px solid var(--Stroke-Border-border-dim, #2A2A2A)',
                  borderRadius: '6px',
                  color: 'var(--Stroke-Button-button-basic-default, #FDFDFD)',
                  fontSize: 13,
                  fontWeight: 500,
                  textTransform: 'none'
                }}
              >
                Cancel
              </Button>
              <Button
                fullWidth
                onClick={handleConfirmCancelMatch}
                sx={{
                  px: 1.75,
                  py: 1.25,
                  background: 'linear-gradient(180deg, #F79420 0%, #F15A26 100%)',
                  borderRadius: '6px',
                  color: 'var(--Stroke-Button-button-cta-default, #FDFDFD)',
                  fontSize: 13,
                  fontWeight: 600,
                  textTransform: 'none'
                }}
              >
                Cancel Match
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>

      <Modal open={Boolean(activeMeetingModal.type)} onClose={handleCloseMeetingModal}>
        {activeModalType === 'future' ? (
          <Box
            sx={{
              width: 550,
              maxWidth: '90vw',
              maxHeight: '90vh',
              bgcolor: '#0F0F0F',
              borderRadius: '8px',
              outline: '1px solid #444444',
              outlineOffset: '-1px',
              overflow: 'hidden',
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            <Box
              sx={{
                alignSelf: 'stretch',
                pl: 3,
                pr: '44px',
                py: 2.5,
                borderBottom: '1px solid #2A2A2A',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between'
              }}
            >
              <Typography sx={{ color: '#FDFDFD', fontSize: 18, fontWeight: 700, fontFamily: 'Inter, sans-serif' }}>
                {meetingModalTitle || 'Future Meetings'}
              </Typography>
              <IconButton size="small" onClick={handleCloseMeetingModal} sx={{ color: '#FDFDFD', position: 'absolute', right: 12, top: 20 }}>
                <CloseIcon />
              </IconButton>
            </Box>

            <Box sx={{ alignSelf: 'stretch', p: 3, display: 'flex', flexDirection: 'column', gap: 2.5, overflowY: 'auto', maxHeight: 'calc(90vh - 100px)' }}>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: '5px', mb: 1 }}>
                <Typography sx={{ color: '#FDFDFD', fontSize: 14, fontWeight: 400 }}>Learning objective</Typography>
                <Typography sx={{ color: '#F79420', fontSize: 16, fontWeight: 700 }}>
                  {objectiveTitle || ''}
                </Typography>
              </Box>

              {meetingHistoryLoading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 4 }}>
                  <CircularProgress size={32} sx={{ color: '#F79420' }} />
                </Box>
              ) : meetingsToShow.length ? (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
                  {meetingsToShow.map((meeting: any, index: number) => {
                    const { month, day, weekday } = getCallDateParts(meeting);
                    const meetingTimeLabel = getMeetingTimeLabel(meeting);
                    const durationLabel =
                      typeof meeting?.callTimeInterval === 'number'
                        ? `${meeting.callTimeInterval}'`
                        : '';
                    const meetingLink = meeting?.meetingLink || meeting?.meeting_link;
                    return (
                      <Box
                        key={meeting?.meetingId || meeting?.callId || index}
                        sx={{
                          p: 1.75,
                          bgcolor: '#1C1C1C',
                          borderRadius: '5px',
                          display: 'flex',
                          alignItems: 'center',
                          gap: 1.75
                        }}
                      >
                        <Box
                          sx={{
                            width: 56,
                            flexShrink: 0,
                            borderRadius: '5px',
                            border: '1px solid #2A2A2A',
                            overflow: 'hidden',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center'
                          }}
                        >
                          <Box sx={{ width: '100%', px: 1.25, py: 0.5, bgcolor: '#3B82F6', textAlign: 'center' }}>
                            <Typography sx={{ color: '#fff', fontSize: 12, fontWeight: 500 }}>
                              {month || ''}
                            </Typography>
                          </Box>
                          <Box sx={{ py: 0.5, textAlign: 'center' }}>
                            <Typography sx={{ color: '#fff', fontSize: 24, fontWeight: 700 }}>{day || ''}</Typography>
                            <Typography sx={{ color: '#fff', fontSize: 12, fontWeight: 500 }}>{weekday || ''}</Typography>
                          </Box>
                        </Box>
                        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 1, minWidth: 0 }}>
                          <Typography sx={{ color: '#FDFDFD', fontSize: 16, fontWeight: 700 }} noWrap>
                            {meeting?.callTitle || `Meeting ${index + 1}`}
                          </Typography>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, flexWrap: 'wrap' }}>
                            {meetingTimeLabel && (
                              <Typography sx={{ color: '#868686', fontSize: 14, fontWeight: 500 }}>
                                {meetingTimeLabel}
                              </Typography>
                            )}
                            {durationLabel && (
                              <>
                                <Box sx={{ width: '1px', alignSelf: 'stretch', minHeight: 14, bgcolor: '#404040' }} />
                                <Typography sx={{ color: '#868686', fontSize: 14, fontWeight: 500 }}>
                                  {durationLabel}
                                </Typography>
                              </>
                            )}
                            <Box sx={{ width: '1px', alignSelf: 'stretch', minHeight: 14, bgcolor: '#404040' }} />
                            <Typography sx={{ color: '#868686', fontSize: 14, fontWeight: 500 }}>
                              {mentorDisplayName}
                            </Typography>
                          </Box>
                        </Box>
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, flexShrink: 0 }}>
                          <Button
                            size="small"
                            onClick={() => {}}
                            sx={{
                              px: 1.25,
                              py: 0.5,
                              fontSize: 12,
                              fontWeight: 500,
                              textTransform: 'none',
                              color: '#FDFDFD',
                              border: '1px solid #2A2A2A',
                              bgcolor: '#1C1C1C',
                              '&:hover': { bgcolor: '#2A2A2A' }
                            }}
                          >
                            Cancel
                          </Button>
                          <Button
                            size="small"
                            onClick={() =>
                              openMeetingWithRedirect(meetingLink, {
                                meetingId: meeting?.meetingId,
                                meetingType: meeting?.meetingType,
                                callDate: meeting?.callDate,
                                callTime: meeting?.callTime,
                                callTimeInterval: meeting?.callTimeInterval
                              })
                            }
                            sx={{
                              px: 1.25,
                              py: 0.5,
                              fontSize: 12,
                              fontWeight: 600,
                              textTransform: 'none',
                              background: 'linear-gradient(180deg, #F79420 0%, #F15A26 100%)',
                              color: '#fff',
                              '&:hover': { background: 'linear-gradient(180deg, #E0851a 0%, #d94e20 100%)' }
                            }}
                          >
                            Join
                          </Button>
                        </Box>
                      </Box>
                    );
                  })}
                </Box>
              ) : (
                <Typography sx={{ color: '#B6B6B6', fontSize: 14, textAlign: 'center' }}>
                  {meetingEmptyMessage || 'No upcoming meetings scheduled.'}
                </Typography>
              )}
            </Box>
          </Box>
        ) : (
          <Box
            sx={{
              width: 550,
              maxWidth: '90vw',
              maxHeight: '90vh',
              bgcolor: '#0F0F0F',
              borderRadius: '8px',
              outline: '1px solid #444444',
              outlineOffset: '-1px',
              overflow: 'hidden',
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            <Box
              sx={{
                alignSelf: 'stretch',
                pl: 3,
                pr: '44px',
                py: 2.5,
                borderBottom: '1px solid #2A2A2A',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between'
              }}
            >
              <Typography sx={{ color: '#FDFDFD', fontSize: 18, fontWeight: 700, fontFamily: 'Inter, sans-serif' }}>
                {meetingModalTitle || 'Meeting History'}
              </Typography>
              <IconButton size="small" onClick={handleCloseMeetingModal} sx={{ color: '#FDFDFD', position: 'absolute', right: 12, top: 20 }}>
                <CloseIcon />
              </IconButton>
            </Box>

            <Box sx={{ alignSelf: 'stretch', p: 3, display: 'flex', flexDirection: 'column', gap: 2.5, overflowY: 'auto', maxHeight: 'calc(90vh - 100px)' }}>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                <Typography sx={{ color: '#FDFDFD', fontSize: 14, fontWeight: 400, fontFamily: 'Inter, sans-serif' }}>
                  Learning objective
                </Typography>
                <Typography sx={{ color: '#F79420', fontSize: 16, fontWeight: 700, fontFamily: 'Inter, sans-serif' }}>
                  {objectiveTitle || ''}
                </Typography>
              </Box>

              {meetingHistoryLoading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 4 }}>
                  <CircularProgress size={32} sx={{ color: '#F79420' }} />
                </Box>
              ) : meetingsToShow.length ? (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
                  {meetingsToShow.map((meeting: any, index: number) => {
                    const isPast = pastFiltered.some(
                      (p: any) => p?.meetingId === meeting?.meetingId || p?.callId === meeting?.callId
                    );
                    const isCanceled = canceledFiltered.some(
                      (c: any) => c?.meetingId === meeting?.meetingId || c?.callId === meeting?.callId
                    );
                    const meetingIdKey = meeting?.meetingId ?? meeting?.callId ?? meeting?._id;
                    const details = meetingIdKey ? meetingDetailsByMeetingId[String(meetingIdKey)] : null;
                    const callReview = details?.callReview ?? meeting?.callReview;
                    const menteeReviewData = meeting?.menteeReview ?? details?.menteeRating ?? meeting?.menteeRating;
                    const mentorReviewData = meeting?.mentorReview ?? details?.mentorRating ?? meeting?.mentorRating;
                    const callDetails = details?.callDetails ?? meeting?.callDetails ?? meeting;
                    const menteeReviewText =
                      menteeReviewData?.review ?? (typeof menteeReviewData === 'string' ? menteeReviewData : null) ?? callReview?.review ?? meeting?.review ?? '';
                    const menteeReviewRating = Number(menteeReviewData?.rating ?? menteeReviewData?.vote ?? callReview?.rating ?? 0);
                    const mentorReviewText =
                      mentorReviewData?.review ?? (typeof mentorReviewData === 'string' ? mentorReviewData : null) ?? mentorReviewData?.feedback ?? '';
                    const mentorReviewRating = Number(mentorReviewData?.rating ?? mentorReviewData?.vote ?? 0);
                    const mentorInfo = details?.mentorInfo ?? activeModalMentor;
                    const mentorName = mentorInfo?.name ?? mentorInfo?.displayName ?? mentorDisplayName;
                    const mentorHeadshot = mentorInfo?.image ?? mentorInfo?.headshot ?? activeModalMentor?.image ?? activeModalMentor?.headshot;
                    const feedbackDate = mentorReviewData?.date ?? mentorReviewData?.createdAt ?? callDetails?.callDate;
                    const { month, day, weekday } = getCallDateParts(meeting);
                    const meetingTimeLabel = getMeetingTimeLabel(meeting);
                    const durationLabel =
                      typeof meeting?.callTimeInterval === 'number'
                        ? `${meeting.callTimeInterval} Min`
                        : '';
                    const statusLabel = isCanceled ? 'Canceled' : 'Completed';
                    const statusColor = isCanceled ? '#868686' : '#00972D';
                    const dateFormatted =
                      month && day
                        ? `${month}/${day}`
                        : feedbackDate
                        ? (typeof feedbackDate === 'string' ? new Date(feedbackDate) : new Date(feedbackDate)).toLocaleDateString('en-US', {
                            month: 'numeric',
                            day: 'numeric',
                            year: '2-digit'
                          })
                        : '';
                    return (
                      <Box
                        key={meeting?.meetingId || meeting?.callId || meeting?._id || index}
                        sx={{
                          p: 1.75,
                          borderRadius: '5px',
                          border: '1px solid #444444',
                          display: 'flex',
                          flexDirection: 'column',
                          gap: 1.25
                        }}
                      >
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Typography sx={{ color: '#FDFDFD', fontSize: 16, fontWeight: 700 }}>
                              {meeting?.callTitle ?? callDetails?.callTitle ?? `Meeting ${index + 1}`}
                            </Typography>
                            <Box
                              sx={{
                                px: 1.5,
                                py: 0.375,
                                borderRadius: '20px',
                                bgcolor: statusColor,
                                color: '#fff',
                                fontSize: 12,
                                fontWeight: 400
                              }}
                            >
                              {statusLabel}
                            </Box>
                          </Box>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2.5, flexWrap: 'wrap' }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                              <AccessTimeIcon sx={{ fontSize: 16, color: '#B6B6B6' }} />
                              <Typography sx={{ color: '#B6B6B6', fontSize: 12 }}>
                                {month && day ? `${month}/${day}` : meeting?.callDate || ''}
                              </Typography>
                            </Box>
                            {meetingTimeLabel && (
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                <AccessTimeIcon sx={{ fontSize: 16, color: '#B6B6B6' }} />
                                <Typography sx={{ color: '#B6B6B6', fontSize: 12 }}>{meetingTimeLabel}</Typography>
                              </Box>
                            )}
                            {durationLabel && (
                              <Typography sx={{ color: '#B6B6B6', fontSize: 12 }}>{durationLabel}</Typography>
                            )}
                          </Box>
                        </Box>
                        {isPast && !isCanceled && (
                          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                              <Typography sx={{ color: '#B6B6B6', fontSize: 12 }}>{w('mentee')} Review:</Typography>
                              {menteeReviewText ? (
                                <Typography sx={{ color: '#B6B6B6', fontSize: 14, fontWeight: 500 }}>
                                  {menteeReviewText}
                                </Typography>
                              ) : (
                                <Typography sx={{ color: '#868686', fontSize: 14, fontStyle: 'italic' }}>No review yet</Typography>
                              )}
                              {menteeReviewRating > 0 && (
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                  <Typography sx={{ color: '#B6B6B6', fontSize: 12 }}>Rated:</Typography>
                                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.25 }}>
                                    {[1, 2, 3, 4, 5].map((star) => (
                                      <StarIcon
                                        key={star}
                                        sx={{
                                          fontSize: 16,
                                          color: star <= menteeReviewRating ? '#FDFDFD' : '#444444'
                                        }}
                                      />
                                    ))}
                                  </Box>
                                </Box>
                              )}
                            </Box>
                            <Box
                              sx={{
                                p: 1.25,
                                bgcolor: '#1C1C1C',
                                borderRadius: '6px',
                                border: '1px solid #2A2A2A',
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 1
                              }}
                            >
                              <Typography sx={{ color: '#B6B6B6', fontSize: 12 }}>{w('mentor')} Review:</Typography>
                              <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.25 }}>
                                <ChatAvatarComponent
                                  image={mentorHeadshot}
                                  firstLetter={mentorName?.charAt(0) || ''}
                                  width="40px"
                                  height="40px"
                                  type="noStatus"
                                />
                                <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 0.5 }}>
                                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <Typography sx={{ color: '#FDFDFD', fontSize: 14, fontWeight: 700 }}>
                                      {mentorName}
                                    </Typography>
                                    <Typography sx={{ color: '#B6B6B6', fontSize: 10, fontWeight: 500 }}>
                                      {dateFormatted}
                                    </Typography>
                                  </Box>
                                  {mentorReviewText ? (
                                    <Typography sx={{ color: '#B6B6B6', fontSize: 14, fontWeight: 400 }}>
                                      {mentorReviewText}
                                    </Typography>
                                  ) : (
                                    <Typography sx={{ color: '#868686', fontSize: 14, fontStyle: 'italic' }}>No review yet</Typography>
                                  )}
                                  {mentorReviewRating > 0 && (
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.25 }}>
                                      {[1, 2, 3, 4, 5].map((star) => (
                                        <StarIcon
                                          key={star}
                                          sx={{
                                            fontSize: 14,
                                            color: star <= mentorReviewRating ? '#FDFDFD' : '#444444'
                                          }}
                                        />
                                      ))}
                                    </Box>
                                  )}
                                </Box>
                              </Box>
                            </Box>
                          </Box>
                        )}
                      </Box>
                    );
                  })}
                </Box>
              ) : (
                <Typography sx={{ color: '#B6B6B6', fontSize: 14, textAlign: 'center' }}>
                  {meetingEmptyMessage || 'No meetings yet.'}
                </Typography>
              )}
            </Box>
          </Box>
        )}
      </Modal>

      {/* Group of Peers Modal */}
      {isPeersPopupOpen && (
        <UserPeersPopup
          open={isPeersPopupOpen}
          onClose={() => handlePeersPopup(false)}
          peersList={peersData?.data.data[0]?.menteeDetails}
          onProfileClick={(mid) => moveToUsercommunityProfile(mid)}
          onChatClick={(each) => navigateMember(each)}
          onCalendarClick={(each) => handleCalendarOpen(each)}
          communityMembers={communityMembers} // Pass the communityMembers prop here
          navigate={navigate} // Pass the navigate prop here
        />
      )}

      {/* Check in with Mentor Modal */}
      {/* <CheckInWithMentorDialog
        checkInWithMentor={checkInWithMentor}
        handleCheckInWithMentor={handleCheckInWithMentor}
      /> */}

      {/* Description Modal */}
      <DescriptionModal
        open={isModalOpen}
        onClose={handleCloseModal}
        // title={`Module ${levelNumber} Description`}
        title={`${levelFullName}`}
        message={levelDescription}
      />

      {/* Preview content for Getting Started */}
      <PreviewContent
        openPreview={openPreview}
        setOpenPreview={setOpenPreview}
        singleListData={articleData}
        loading={articleDataLoading}
      />

      {/* Recruit New Mentor */}
      {recruitModalOpen && (
        <RecruitNewMentor
          title=""
          open={recruitModalOpen}
          onClose={() => setRecruitModalOpen(false)}
          mentorsList={recruitMentors}
          onProfileClick={(mid: any) => moveToUsercommunityProfile(mid)}
          onChatClick={(each: any) => navigateMember(each)}
          onCalendarClick={(each: any) => handleCalendarOpen(each)}
          objId={getObjectiveIdentifier(learningObjectives[currentObjectiveIndex]) ?? ''}
          grpId={groupId}
          apiType="all"
          learningObjective={learningObjectives[currentObjectiveIndex]}
        />
      )}

      {/* Mentor Profile Modal */}
      <MenteeProfileModal
        open={profileModalOpen}
        onClose={() => {
          setProfileModalOpen(false);
          setProfileMentor(null);
        }}
        user={profileMentor || {}}
      />

      {/* Getting Started Modal */}
      {/* <GettingStartedModal
        open={openGettingStartedModal}
        handleClickGettingStartedModal={handleClickGettingStartedModal}
        allowEditing={groupDetails?.data?.includeTask && groupDetails?.data?.allowEditing ? true : false}
        selectedStep={selectedStep}
      /> */}

      {/* Welcome Modals */}
      {/* <WelcomeModals open={openGettingStartedModal} handleClickWelcomeModals={handleClickGettingStartedModal} /> */}
    </>
  );
};

export default Mentee;
